// This file is auto-generated by @hey-api/openapi-ts

export type AccessInfo = {
    Active: boolean;
    IsOpen: boolean;
    ClosedReason: ClosedReason | null;
};

/**
 * Result returned when a messaging conversation product is added to the basket.
 */
export type AddMessagingConversationResult = {
    /**
     * The identifier of the created basket product.
     */
    BasketProductId: number;
    /**
     * Validation status for submitted form answers, keyed by form id.
     */
    AnswerStatus: {
        [key: string]: Array<AnswerFormQuestionUpdateResult>;
    };
    /**
     * Overall validation result for the product.
     */
    ValidationResult: ValidationResultType;
    /**
     * Upload results for any attached files.
     */
    readonly FileUploadResults: Array<FileMapResult>;
    /**
     * Resolved participants (patient and legal guardians) for representative flows. Empty when not representing.
     */
    Participants: Array<BasketParticipantApiModel>;
};

export type AddMessagingConversationResultDataEnvelope = {
    /**
     * Result returned when a messaging conversation product is added to the basket.
     */
    Data?: AddMessagingConversationResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type AdditionalParticipantApiInput = {
    IdentityCode: string;
    IdentityNumber: string;
};

export type AddressModel = {
    Formatted: string | null;
    Address: string | null;
    Address2: string | null;
    City: string | null;
    PostalCode: string | null;
    Country: string | null;
};

export type AnswerApiModel = {
    QuestionId: number;
    StringValue: string | null;
    IntValue: number | null;
    BoolValue: boolean | null;
    Choices: Array<number>;
};

export enum AnswerFormQuestionErrorStatus {
    Ok = 'Ok',
    QuestionNotFound = 'QuestionNotFound',
    IncompatibleAnswerType = 'IncompatibleAnswerType',
    IncompatibleAnswerRange = 'IncompatibleAnswerRange'
}

export type AnswerFormQuestionUpdateResult = {
    QuestionId: number;
    Status: AnswerFormQuestionErrorStatus;
};

export type AnswerFormQuestionUpdateResultListDataEnvelope = {
    Data?: Array<AnswerFormQuestionUpdateResult> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type AppConfigApiModel = {
    UnitId: number;
    IdpInstanceUrl: string | null;
};

export type AppConfigApiModelDataEnvelope = {
    Data?: AppConfigApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type AppConfigInfo = {
    Id: number;
    DisplayName: string;
    AppStoreId: string | null;
    StoreCompanyName: string | null;
    AndroidPackageId: string | null;
};

export type AppConfigInfoDataEnvelope = {
    Data?: AppConfigInfo | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum AppPlatform {
    IOs = 'iOS',
    Android = 'Android'
}

export type AppWebInfoApiModel = {
    Path: string;
};

export type AppWebInfoApiModelDataEnvelope = {
    Data?: AppWebInfoApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type AppointmentApiModel = {
    BookingId: number;
    ResourceId: number | null;
    Ticket: string;
    UnitId: number;
    ReceptionId: number;
    Role: BookingParticipantRole;
    IsMainSubject: boolean;
    Start: string;
    Duration: number;
    Reason: string | null;
    AsAgentFor: string | null;
    AsAgentForName: string | null;
    PerformMediaTest: boolean;
    /**
     * Indicates whether this appointment has been previously seen by the user or not.
     */
    HasSeen: boolean;
    MyParticipant: ParticipantModel;
    OtherParticipants: Array<ParticipantModel>;
    ReservedUntil: string | null;
    Reserved: boolean;
    Cancelable: boolean;
    Reschedulable: boolean;
    CompletedTimestamp: string | null;
    Condition: ClientConditionApiModel | null;
    InitialSymptoms: Array<string> | null;
    Price: CurrencyDisplay | null;
    Payment: PaymentApiModel | null;
    Files: Array<FileApiModel>;
    Forms: Array<RespondantStatusApiModel>;
    /**
     * @deprecated
     */
    readonly VideoService: string;
    CompletedRedirectUrl: string | null;
    PhysicalLocationId: number | null;
    Source: BookingSource;
    VonageEncryptionRequired: boolean;
    VonageProxyUrl: string | null;
};

export type AppointmentApiModelDataEnvelope = {
    Data?: AppointmentApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type AppointmentApiModelListDataEnvelope = {
    Data?: Array<AppointmentApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type AuthMethodApiModel = {
    Name: string | null;
    ProviderId: string;
    MethodId: string;
    Schemes: Array<AuthSchemeApiModel>;
    ImageUrl: string | null;
    HasImage: boolean;
};

export type AuthMethodApiModelListDataEnvelope = {
    Data?: Array<AuthMethodApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum AuthMethodUsage {
    Client = 'Client',
    Office = 'Office',
    Outsider = 'Outsider'
}

export enum AuthScheme {
    Native = 'Native',
    Redirect = 'Redirect',
    WebView = 'WebView'
}

export type AuthSchemeApiModel = {
    Scheme: AuthScheme;
};

export type BasketContentsApiModel = {
    PriceString: string;
    Price: number;
    Currency: string;
    ReceptionId: number;
    MessagingProducts: Array<MessagingBasketProductApiModel> | null;
};

export type BasketContentsApiModelDataEnvelope = {
    Data?: BasketContentsApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type BasketFileContentReference = {
    Id: string;
    FullUrl: string;
    ThumbUrl: string | null;
    ContentType: string;
};

export type BasketFileReferenceInput = {
    FileReference: string;
};

/**
 * An input model projection of answers in the basket. VisibaCare.Business.Basket.FormOperations.FormQuestionAnswer for the output projection.
 * The names of the fields are synced (enforced through tests) to make sure the it could be considered the same
 * model from a consuming client perspective.
 */
export type BasketFormAnswer = {
    QuestionId: number;
    IntValue: number | null;
    BoolAnswer: boolean | null;
    TextAnswer: string | null;
    MultiAnswer: Array<number> | null;
};

/**
 * Represents a participant in a messaging conversation (e.g. patient or legal guardian).
 */
export type BasketParticipantApiModel = {
    /**
     * Server-generated participant identifier, unique within the basket product.
     */
    Id: number;
    /**
     * If the participant is a client, this contains the id.
     */
    ClientId: number | null;
    /**
     * The participant's given name, if available from the PU service.
     */
    GivenName: string | null;
    /**
     * The participant's surname, if available from the PU service.
     */
    Surname: string | null;
    /**
     * Whether the participant is the patient or a legal guardian.
     */
    Type: ParticipantType;
    /**
     * Whether this participant has been selected for inclusion when the basket is committed.
     */
    Selected: boolean;
};

export type BookSlotApiInput = {
    Reason?: string | null;
    AsAgentFor?: string | null;
    AsAgentForName?: string | null;
    TimeslotLockId?: string | null;
    Files: Array<string>;
    ExternalData: Array<string>;
    ConditionId?: number | null;
    RedRobinSessionId?: string | null;
    AdditionalParticipants: Array<AdditionalParticipantApiInput>;
};

export enum BookingParticipantRole {
    Host = 'Host',
    User = 'User'
}

export enum BookingParticipantSubjectRole {
    MainSubject = 'MainSubject',
    LegalGuardian = 'LegalGuardian'
}

export enum BookingSource {
    Unknown = 'Unknown',
    Invitation = 'Invitation',
    Timeslot = 'Timeslot',
    WaitingRoom = 'WaitingRoom'
}

export type BooleanDataEnvelope = {
    Data: boolean;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type ButtonApiModel = GuiComponentDataApiModel & {
    readonly Url: string;
    OpenUrlWith: OpenUrlWithKind;
    readonly Title?: string | null;
    readonly RequiresAuthentication: boolean;
    readonly OpenAnotherApp: boolean;
    readonly HasBrandedNavbar: boolean;
};

export type ButtonHyperlinkApiModel = ButtonApiModel & {};

export type ButtonIconApiModel = ButtonApiModel & {
    Subtitle?: string | null;
    readonly IconPngUrl?: string | null;
    readonly IconSvgUrl: string;
};

export type CallStatusApiModel = {
    CompletedTimestamp: string | null;
    HasConnectedResourceOrHost: boolean;
    ParticipantCount: number;
};

export type CallStatusApiModelDataEnvelope = {
    Data?: CallStatusApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type CancelAppointmentInput = {
    CancellationReason?: string | null;
};

export type CancelBookingApiResult = {
    NewTimeslot: TimeslotApiModel | null;
};

export type CancelBookingApiResultDataEnvelope = {
    Data?: CancelBookingApiResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type CareCompanionSessionApiModel = {
    SessionId: string;
    ConversationId: string;
    AccessToken: string;
    ApiBaseUrl: string;
    ExpiresAt: string;
};

export type CareCompanionSessionRequestApiModel = {
    SessionId: string | null;
};

export type CaseApiModel = {
    readonly AsAgentFor: string | null;
    readonly AsAgentForName: string | null;
    readonly Condition: string | null;
    readonly InitialSymptoms: Array<string> | null;
    readonly UnitId: number;
    Type: ClientCaseType;
    readonly Time: string;
    readonly Completed: boolean;
    readonly ReservedUntil: string | null;
    readonly Reserved: boolean;
    Cancelable: boolean;
    Reschedulable: boolean;
    readonly ReceptionName: string | null;
    readonly AppointmentTicket: string | null;
    readonly MessageConversationId: number | null;
    ActingParticipantSubjectRole: BookingParticipantSubjectRole | null;
    readonly OtherParticipants: Array<CaseOtherParticipantModel>;
    PreviousOwner: PreviousOwnerInfo | null;
    readonly PhysicalLocationName: string | null;
    readonly UnhandledIssues: Array<ClientCaseIssueType>;
    /**
     * Deprecated and replaced by VisibaCare.Api.Client.v2.Models.Cases.CaseApiModel.UnhandledIssues.
     * Only contains enum values that are supported by app versions up until 3.26 and Web 4.26.
     * This is due to their inflexible handling of enum values, which breaks by adding new ones.
     * @deprecated
     */
    readonly Issues: Array<ClientCaseIssueType>;
};

export type CaseApiModelListDataEnvelope = {
    Data?: Array<CaseApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type CaseMissingFormResponses = {
    Type: ClientCaseDefinition;
    Appointment: PrioritizedAppointmentType | null;
    Case: CurrentMessagingUnreadMayHaveMessages | null;
    Forms: Array<string>;
};

export type CaseOtherParticipantModel = {
    Title: string | null;
    DescriptiveTitle: string | null;
    Name: string | null;
    ProfileImageUrl: string | null;
    Role: BookingParticipantRole;
    LeftTimestamp: string | null;
    SubjectRole: BookingParticipantSubjectRole | null;
};

export type CasePaymentInformation = {
    Amount: number;
    readonly AmountString: string;
    Currency: string;
    readonly ReceiptUrl: string | null;
    readonly IsPayed: boolean;
};

export type CaseResourceDto = {
    FirstName: string;
    LastName: string;
    Title: string | null;
    readonly HasReadUntilTimestamp: string | null;
};

export enum ChannelKind {
    Custom = 'Custom',
    Timeslots = 'Timeslots',
    DropIn = 'DropIn',
    Messaging = 'Messaging',
    RedRobin = 'RedRobin',
    Navigation = 'Navigation'
}

export enum ClientCaseDefinition {
    Appointment = 'Appointment',
    MessagingConversation = 'MessagingConversation',
    PhysicalAppointment = 'PhysicalAppointment'
}

export enum ClientCaseIssueType {
    AwaitingPayment = 'AwaitingPayment',
    AwaitingFormResponse = 'AwaitingFormResponse',
    UnreadMessages = 'UnreadMessages',
    NewIncoming = 'NewIncoming'
}

export enum ClientCaseType {
    Appointment = 'Appointment',
    MessagingConversation = 'MessagingConversation',
    PhysicalAppointment = 'PhysicalAppointment'
}

export type ClientConditionApiModel = {
    readonly Id: number;
    Name: string | null;
    InfoScreen: ConditionInfoScreenApiModel | null;
};

export type ClientConditionApiModelListDataEnvelope = {
    Data?: Array<ClientConditionApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type ClientPersonalizedCaseApiModel = {
    Id: number;
    ReceptionId: number;
    Reason: string | null;
    ReasonFormat: TextFormat;
    Condition: ReceptionConditionDto | null;
    TimeZoneInfo: string;
    CreatedTimestamp: string;
    StartedTimestamp: string | null;
    CompletedTimestamp: string | null;
    LastMessageTimestamp: string | null;
    HasReadUntilTimestamp: string | null;
    UnreadMessages: number;
    HasFiles: boolean;
    AllowClientResponse: boolean;
    readonly AllowClientToComplete: boolean;
    readonly AnonymizeImmediatelyAfterCompletion: boolean;
    /**
     * @deprecated
     */
    readonly UserInitiatedAnonymization: boolean;
    PaymentInfo: CasePaymentInformation | null;
    ResourceInfo: CaseResourceDto | null;
};

export type ClientPersonalizedCaseApiModelDataEnvelope = {
    Data?: ClientPersonalizedCaseApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum ClosedReason {
    Other = 'Other',
    OutsideMonitoredHours = 'OutsideMonitoredHours',
    CapLimitReached = 'CapLimitReached'
}

export enum CloudMessageTargetType {
    None = 'None',
    Android = 'Android',
    IOs = 'iOS'
}

export type CommitResult = {
    ValidationResult: ValidationResultType;
    Status: CommitResultStatus;
    PaymentBillId: number | null;
    CommitJobId: number | null;
};

export type CommitResultDataEnvelope = {
    Data?: CommitResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum CommitResultStatus {
    ValidationErrors = 'ValidationErrors',
    PendingPayment = 'PendingPayment',
    ReservationCommitted = 'ReservationCommitted',
    CommitInProgress = 'CommitInProgress'
}

export type CommitSuccessResult = {
    InvoiceUrl: string | null;
    Status: QueryCommitStatus;
    MessagingCases: Array<MessagingCaseCommittedApiModel>;
};

export type CommitSuccessResultDataEnvelope = {
    Data?: CommitSuccessResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum ConclusionCard {
    Generic = 'Generic',
    Messaging = 'Messaging',
    VideoAppointment = 'VideoAppointment'
}

export type ConditionInfoScreenApiModel = {
    Id: number;
    ReceptionConditionId: number;
    Flows: Array<ReceptionConditionInfoScreenFlow>;
    Description: string | null;
    Buttons: Array<ConditionInfoScreenButtonApiModel>;
};

export type ConditionInfoScreenButtonApiModel = {
    Id: number;
    Icon: string;
    Title: string | null;
    Description: string | null;
    Url: string | null;
};

export enum Controls {
    WebCommonHeaderSignOutButton = 'Web_Common_HeaderSignOutButton',
    WebAppointmentTakeScreenshotButton = 'Web_Appointment_TakeScreenshotButton',
    WebAppointmentSharedFiles = 'Web_Appointment_SharedFiles',
    WebAreaStart = 'Web_Area_Start',
    WebAppointmentShareScreenButton = 'Web_Appointment_ShareScreenButton',
    WebIcdOutcomeInput = 'Web_ICD_Outcome_Input',
    WebAppointmentCloseAfterCallButton = 'Web_Appointment_CloseAfterCallButton'
}

export type CoordinatesModel = {
    Longitude: number;
    Latitude: number;
};

export type CreateSearchLimitationArg = {
    FirstSearchDate?: string | null;
    LastSearchDate?: string | null;
    RelativeStart?: string | null;
    RelativeEnd?: string | null;
    HcpId?: number | null;
    ForClientId?: number | null;
    ForGuestId?: number | null;
    PhysicalLocationId?: number | null;
    AbortUrl?: string | null;
    NoAvailabilityUrl?: string | null;
};

export type CurrencyCodeApiModel = {
    ThreeLetterCode: string;
    DisplayName: string;
    SmallestDenominatorMultiplier: number;
    ShouldRoundToCommonDenominator: boolean;
};

export type CurrencyCodeApiModelDataEnvelope = {
    Data?: CurrencyCodeApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type CurrencyDisplay = {
    readonly Formatted: string;
    readonly Value: number;
    Info: Info;
};

export type CurrentAppointmentParticipant = {
    Name: string | null;
    ProfileImageUrl: string | null;
};

export type CurrentMessagingUnread = {
    CaseId: number;
    ReceptionName: string | null;
    UnreadCount: number;
    LastMessageFromPeerTimestamp: string;
};

export type CurrentMessagingUnreadMayHaveMessages = {
    CaseId: number;
    ReceptionName: string | null;
    UnreadCount: number;
    LastMessageFromPeerTimestamp: string | null;
};

export type DateCountPairApiModel = {
    Date: string;
    Count: number;
};

export type Day = {
    Date: string;
    DayOfWeek: number;
    ClosedWholeDay: boolean;
    Slots: Array<Slot>;
};

export enum DayOfWeek {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday'
}

export type DayUtc = {
    Date: string;
    DayOfWeek: number;
    ClosedWholeDay: boolean;
    Slots: Array<SlotUtc>;
};

export type DeleteBasketApiResult = {
    [key: string]: unknown;
};

export type DeleteBasketApiResultDataEnvelope = {
    Data?: DeleteBasketApiResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type DeleteFilesResultApiModel = {
    FileStatus: {
        [key: string]: boolean;
    };
};

export type DeleteFilesResultApiModelDataEnvelope = {
    Data?: DeleteFilesResultApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type DemandManagementStatus = {
    Status: Status;
    ClosedReason: ClosedReason | null;
    UiTemplate: UiTemplate;
    NextEvent: string | null;
};

export type Diagnosis = {
    NodeId: number;
    Probability: number;
};

export enum DocumentType {
    TermsOfService = 'TermsOfService',
    PrivacyPolicy = 'PrivacyPolicy'
}

export type DropInApiModel = {
    Id: number;
    Name: string;
    Description: string | null;
    InQueueText: string | null;
    UrlAlias: string;
    AllowsGuests: boolean;
    /**
     * @deprecated
     */
    OpenHours: Array<Day>;
    OpenHoursUtc: Array<DayUtc>;
    IsOpen: boolean;
    CurrentWaitTime: number;
    MinimumShownWaitTime: number;
    HandshakeTimeout: number;
    RequiresPayment: boolean;
    TicketPrice: CurrencyDisplay | null;
};

export type DropInApiModelDataEnvelope = {
    Data?: DropInApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type DropInApiModelListDataEnvelope = {
    Data?: Array<DropInApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type DropInEnqueueApiModel = {
    NationalIdentityNumber: string | null;
    GivenName: string | null;
    Surname: string | null;
    Email: string | null;
    Phone: string | null;
    Reason: string | null;
    LanguageCode: string | null;
    AsAgentFor: string | null;
    AsAgentForName: string | null;
    CountryCode: string | null;
    FileIdentifiers: Array<string> | null;
    ExternalDataIdentifiers: Array<string>;
    RespondantId: number | null;
    ConditionId: number | null;
    RedRobinSessionId: string | null;
};

export type DropInTicketApiModel = {
    DropInRoomId: number;
    UnitId: number | null;
    Ticket: string;
    Reason: string | null;
    AsAgentFor: string | null;
    PerformMediaTest: boolean;
    DropInRoomUrlAlias: string | null;
    MayEnterQueue: boolean;
    Condition: ClientConditionApiModel | null;
    InitialSymptoms: Array<string> | null;
    Payment: PaymentApiModel | null;
    Files: Array<FileApiModel>;
    Forms: Array<RespondantStatusApiModel>;
    CompletedRedirectUrl: string | null;
};

export type DropInTicketApiModelDataEnvelope = {
    Data?: DropInTicketApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type Envelope = {
    Successful: boolean;
    ErrorCode: string | null;
    ErrorMessage: string | null;
    ValidationErrors: {
        [key: string]: Array<string>;
    } | null;
};

export enum ExecuteActionStatus {
    Success = 'Success',
    DryRun = 'DryRun',
    RequiredParametersNotProvided = 'RequiredParametersNotProvided',
    RedRobinConnectionNotFound = 'RedRobinConnectionNotFound',
    ResourceNotFound = 'ResourceNotFound',
    CreateDeeplinkFailed = 'CreateDeeplinkFailed',
    FailedToCreateMessagingCase = 'FailedToCreateMessagingCase',
    InvalidReceptionConfig = 'InvalidReceptionConfig',
    WebhookFailed = 'WebhookFailed'
}

export type ExternalDataModel = {
    Origin: string;
    Type: ExternalDataType;
    Data?: unknown;
};

export type ExternalDataResult = {
    ExternalData: Array<string>;
};

export type ExternalDataResultDataEnvelope = {
    Data?: ExternalDataResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum ExternalDataType {
    Unknown = 'Unknown',
    NameValue = 'NameValue'
}

export enum FieldOption {
    Optional = 'Optional',
    Required = 'Required',
    ReadOnly = 'ReadOnly'
}

export type FileApiModel = {
    Id: string;
    Name: string;
    Length: number;
    Type: string;
    DownloadUrl: string | null;
    ThumbnailUrl: string | null;
};

export type FileMapResult = {
    FileId: string;
    ImageUrl: string | null;
    ThumbUrl: string | null;
    ContentType: string | null;
    Success: boolean;
};

export type FileMapResultListDataEnvelope = {
    Data?: Array<FileMapResult> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type FileUploadApiModel = {
    Id: string;
    DownloadUrl: string;
    UploadUrl: string;
    DeleteUrl: string;
    ThumbnailUrl: string | null;
};

export type FileUploadApiModelDataEnvelope = {
    Data?: FileUploadApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type FilterOption = {
    Id: number;
    Name: string | null;
};

export type Form = {
    Id: number;
    Header: string | null;
    PageCount: number;
    Answered: boolean;
};

export type FormApiModel = {
    Id: number;
    Header: string | null;
    Description: string | null;
    Conditions: Array<number>;
};

export type FormApiModelListDataEnvelope = {
    Data?: Array<FormApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type FormGraphApiModel = {
    PageGroups: Array<PageGroupApiModel>;
    Id: number;
    Header: string | null;
    Description: string | null;
    Conditions: Array<number>;
};

export type FormGraphApiModelDataEnvelope = {
    Data?: FormGraphApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum FormOpportunity {
    BeforeBooking = 'BeforeBooking',
    AfterBooking = 'AfterBooking',
    BeforeCase = 'BeforeCase'
}

export type FormQuestionAnswer = {
    QuestionId: number;
    TextAnswer: string | null;
    IntValue: number | null;
    BoolAnswer: boolean | null;
    MultiAnswer: Array<number> | null;
};

export type FormQuestionAnswerListDataEnvelope = {
    Data?: Array<FormQuestionAnswer> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum FormQuestionType {
    YesNo = 'YesNo',
    Multiline = 'Multiline',
    MultiChoice = 'MultiChoice',
    SingleChoiceRadio = 'SingleChoiceRadio',
    SingleChoiceSelect = 'SingleChoiceSelect'
}

export type GetRegistrationApiModel = {
    Nationality: string | null;
    NationalIdentityNumber: string | null;
    Phone: string | null;
    FirstName: string | null;
    LastName: string | null;
    Email: string | null;
    NationalIdentityNumberRequirement: FieldOption;
    PhoneRequirement: FieldOption;
    EmailRequirement: FieldOption;
};

export type GetRegistrationApiModelDataEnvelope = {
    Data?: GetRegistrationApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type GuiComponentApiModel = {
    readonly Id: number;
    readonly Type: string;
    readonly Order: number;
    HorizontalAlignment: HorizontalAlignment | null;
    Data: GuiComponentDataApiModel | ButtonApiModel | ButtonHyperlinkApiModel | ButtonIconApiModel | ImageApiModel | ListApiModel | ListDirectionalApiModel | RecentVisitsApiModel | ListedAtReceptionsApiModel | SearchApiModel | SpacerApiModel | TextApiModel;
    Channel: ChannelKind | null;
};

export type GuiComponentApiModelListDataEnvelope = {
    Data?: Array<GuiComponentApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type GuiComponentDataApiModel = {
    [key: string]: unknown;
};

export type GuidDataEnvelope = {
    Data: string;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type HomeGuiComponentsApiModel = {
    LayoutSmall: Array<GuiComponentApiModel>;
    LayoutLarge: Array<GuiComponentApiModel>;
};

export type HomeGuiComponentsApiModelDataEnvelope = {
    Data?: HomeGuiComponentsApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum HorizontalAlignment {
    Start = 'Start',
    End = 'End'
}

export type IdentifierConflictsApiModel = {
    IdentifiersValid: boolean;
    IdentifiersAlreadyInUse: boolean;
};

export type IdentifierConflictsApiModelDataEnvelope = {
    Data?: IdentifierConflictsApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type IdentityApiModel = {
    UserType: UserType;
    LicenceHolderId: number;
    Id: number;
    Nationality: string | null;
    NationalIdentityNumber: string | null;
    Phone: string | null;
    FirstName: string | null;
    LastName: string | null;
    Email: string | null;
    RemoteLoginScheme: string | null;
    NationalIdentityNumberRequirement: FieldOption;
    PhoneRequirement: FieldOption;
    EmailRequirement: FieldOption;
    NameRequirement: FieldOption;
    /**
     * Who from VisibaCare.Api.Client.v2.Models.Identity.IdentityApiModel.CanRepresent am I currently representing?
     * If null, I am not representing anyone and I act on my own behalf.
     */
    RepresentingId: string | null;
    /**
     * Who am I able to represent?
     * Usually my children.
     */
    CanRepresent: Array<RepresentablePerson>;
};

export type IdentityApiModelDataEnvelope = {
    Data?: IdentityApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type IdpListMethod = {
    Scheme: string;
    Name: string;
    Description: string;
    UseIframe: boolean;
};

export type ImageApiModel = GuiComponentDataApiModel & {
    readonly ImageUrl: string;
    readonly ImageHeight: number;
    readonly ImageWidth: number;
    readonly AltText?: string | null;
};

export type Info = {
    readonly ThreeLetterCode: string;
    readonly DisplayName: string;
    readonly SmallestDenominatorMultiplier: number;
    readonly ShouldRoundToCommonDenominator: boolean;
};

export type InformationGatheringAddressInput = {
    AddressLine1: string;
    AddressLine2: string;
    TownOrCity: string;
    Postcode: string;
};

export enum InformationGatheringDestination {
    RedRobin = 'red-robin',
    Messaging = 'messaging',
    CareNavigation = 'care-navigation'
}

export type InformationGatheringEligibilityApiModel = {
    IsEligible: boolean;
};

export type InformationGatheringPatientInput = {
    FirstName?: string | null;
    LastName?: string | null;
    DateOfBirth?: string | null;
    NhsNumber?: string | null;
    SexAssignedAtBirth?: InformationGatheringSexAssignedAtBirth | null;
    PhoneNumber: string;
    HomeAddress?: InformationGatheringAddressInput | null;
    CurrentLocationIsHomeAddress: boolean;
    CurrentLocation: InformationGatheringAddressInput;
};

export type InformationGatheringRepresentativeInput = {
    RelationshipToPatient: InformationGatheringRepresentativeRelationship;
    PhoneNumber: string;
};

export enum InformationGatheringRepresentativeRelationship {
    ParentOrGuardian = 'parent-or-guardian',
    FamilyMember = 'family-member',
    FriendOrNeighbour = 'friend-or-neighbour',
    HealthcareProfessionalOrCarer = 'healthcare-professional-or-carer',
    Other = 'other'
}

export enum InformationGatheringSexAssignedAtBirth {
    Female = 'female',
    Male = 'male',
    PreferNotToSay = 'prefer-not-to-say'
}

export type InformationGatheringSubmissionApiModel = {
    SubmissionId: string;
};

/**
 * Completed patient and representative information gathered during the NHS App pilot journey.
 */
export type InformationGatheringSubmissionInput = {
    Role: string;
    Patient: InformationGatheringPatientInput;
    Destination: InformationGatheringDestination;
    Representative?: InformationGatheringRepresentativeInput | null;
};

export type Int32DataEnvelope = {
    Data: number;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type Int64DataEnvelope = {
    Data: number;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type InviteablePersonApiModel = {
    Name: string;
    IdentityCode: string;
    IdentityNumber: string;
    RelationshipTypes: Array<PersonRelationshipType>;
};

export type InviteablePersonApiModelListDataEnvelope = {
    Data?: Array<InviteablePersonApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type LegalGuardianInput = {
    IdentityCode: string;
    IdentityNumber: string;
};

export type Licenceholder = {
    Id: number;
    RootUnit: number;
    DisplayName: string;
    LegalName: string;
    RequireClientEmail: boolean;
    RequireClientPhone: boolean;
    HasMultipleLandingPages: boolean;
    GlobalCustomerId: string;
    DaysToDepersonalizeClientAfterRequest: number;
    SupportInformationUrl: string | null;
};

export type LimitationNavigation = {
    AbortUrl: string | null;
    NoAvailabilityUrl: string | null;
};

export type ListApiModel = GuiComponentDataApiModel & {
    readonly Title?: string | null;
    readonly Items: Array<GuiComponentApiModel>;
};

export enum ListDirection {
    Vertical = 'Vertical',
    Horizontal = 'Horizontal'
}

export type ListDirectionalApiModel = ListApiModel & {
    Direction: ListDirection;
};

export type ListedAtReceptionsApiModel = GuiComponentDataApiModel & {
    readonly Title?: string | null;
};

export type Locale = {
    DefaultLanguage: string;
    AvailableLanguages: Array<string>;
    DefaultCountry: string;
    SupportedCountries: Array<SupportedCountryInfo>;
    TimeZoneIana: string;
};

export type LocaleDataEnvelope = {
    Data?: Locale | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum LocalityType {
    All = 'All',
    Digital = 'Digital',
    Physical = 'Physical'
}

export type MessageOtherParticipantModel = {
    readonly Title: string | null;
    readonly DescriptiveTitle: string | null;
    readonly Name: string | null;
    readonly ProfileImageUrl: string | null;
    readonly LeftTimestamp: string | null;
};

export type MessagingBasketProductApiModel = {
    Id: number;
    PriceString: string;
    Price: number;
    Currency: string;
    Reason: string;
    ReasonFormat: TextFormat;
    ReceptionConditionId: number | null;
    InformationGatheringSubmissionId: string | null;
    ReceptionCondition: string | null;
    NeedsFormAnswers: boolean;
    Forms: Array<Form> | null;
    Files: Array<BasketFileContentReference> | null;
    Participants: Array<BasketParticipantApiModel>;
};

export type MessagingCaseCommittedApiModel = {
    Id: number;
    readonly ReceiptLink: string | null;
};

export type MessagingConversationApiModel = {
    readonly Id: number;
    readonly ParticipantId: number;
    Condition: ClientConditionApiModel | null;
    Forms: Array<RespondantStatusApiModel>;
    readonly CompletedTimestamp: string | null;
    readonly HasReadUntilTimestamp: string | null;
    readonly UnreadMessages: number;
    readonly Reason: string | null;
    readonly OtherParticipants: Array<MessageOtherParticipantModel>;
    readonly Files: Array<FileApiModel>;
    readonly AllowClientResponse: boolean;
    readonly AllowClientToComplete: boolean;
    readonly AnonymizeImmediatelyAfterCompletion: boolean;
};

export type MessagingConversationApiModelDataEnvelope = {
    Data?: MessagingConversationApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type MessagingConversationApiModelListDataEnvelope = {
    Data?: Array<MessagingConversationApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type MessagingConversationInput = {
    Reason?: string | null;
    ReasonFormat: TextFormat;
    ReceptionConditionId?: number | null;
    FormAnswers?: {
        [key: string]: Array<BasketFormAnswer>;
    } | null;
    FileReferences?: Array<BasketFileReferenceInput> | null;
    ExternalDataReferences?: Array<string> | null;
    /**
     * The national identity number of the individual the agent is acting on behalf of.
     */
    AsAgentFor?: string | null;
    RedRobinSessionId?: string | null;
    InformationGatheringSubmissionId?: string | null;
};

export type MessagingLegalGuardianInput = {
    IdentityCode: string;
    IdentityNumber: string;
};

export type MessagingUpdateLegalGuardiansApiInput = {
    /**
     * The desired list of legal guardians invited to the conversation. Replace semantics: any guardian
     * participant currently on the case that is not in this list will be uninvited; any guardian in
     * this list that is not currently invited will be added as a participant.
     */
    LegalGuardians: Array<MessagingLegalGuardianInput>;
};

export type MonitoredHours = {
    DayOfWeek: DayOfWeek | null;
    Open: string;
    Close: string | null;
};

export type MultipleUnreadMessages = {
    UnreadMessagesCount: number;
    LastMessageFromPeerTimestamp: string;
};

export type NavigateRequest = {
    InformationGatheringSubmissionId?: string | null;
    DryRun: boolean;
    NumberParameters: {
        [key: string]: number;
    };
    StringParameters: {
        [key: string]: string;
    };
    Diagnoses: Array<Diagnosis>;
    PresentingComplaints: Array<PresentingComplaint>;
};

export type NavigationActionResult = {
    ExecuteActionStatus: ExecuteActionStatus;
    ConclusionCard: ConclusionCard | null;
    Deeplink: string | null;
};

export type NavigationBookingHandoffResult = {
    SubjectRelation: NavigationBookingSubjectRelation;
};

export enum NavigationBookingSubjectRelation {
    AuthenticatedClient = 'AuthenticatedClient',
    RepresentedPatient = 'RepresentedPatient'
}

export type NotificationComplianceSettingsApiModel = {
    AllowEmail: boolean;
    AllowSms: boolean;
    /**
     * Indicates whether the specified settings are up-to-date and have been configured by the user or not and
     * whether the user should be prompted to change them upon signing in.
     */
    UpToDate: boolean;
};

export type NotificationComplianceSettingsApiModelDataEnvelope = {
    Data?: NotificationComplianceSettingsApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type Offer = {
    IsListedToClients: boolean;
    MessagingIsUnlisted: boolean;
    HasAreaBooking: boolean;
    HasAreaDropIn: boolean;
    HasAreaMessaging: boolean;
    HasPhysicalLocation: boolean;
    HasConditionWorkflow: boolean;
    AllowClientAgents: boolean;
    HideProvidedByVisibaCare: boolean;
    Controls: Array<Controls>;
};

export enum OpenUrlWith {
    IFrame = 'IFrame',
    SameTab = 'SameTab',
    NewTab = 'NewTab'
}

export enum OpenUrlWithKind {
    IFrame = 'IFrame',
    SameTab = 'SameTab',
    NewTab = 'NewTab'
}

export type OptionApiModel = {
    Id: number;
    Text: string | null;
};

export type PageApiModel = {
    Id: number;
    Header: string | null;
    Description: string | null;
    Questions: Array<QuestionApiModel>;
};

export type PageGroupApiModel = {
    Id: number;
    Header: string | null;
    Description: string | null;
    Pages: Array<PageApiModel>;
};

export type ParticipantModel = {
    ResourceId: number | null;
    Title: string | null;
    DescriptiveTitle: string | null;
    Name: string | null;
    ProfileImageUrl: string | null;
    ParticipantId: number;
    IsMainSubject: boolean;
    IsLegalGuardian: boolean;
    IsExternalGuest: boolean;
    ExternalGuestAuthProviderId: string | null;
    ExternalGuestAuthMethodId: string | null;
    RedRobinSessionId: string | null;
};

export enum ParticipantType {
    Patient = 'Patient',
    LegalGuardian = 'LegalGuardian'
}

export type PaymentApiModel = {
    State: States;
    ReceiptUrl: string | null;
    BillId: number;
};

export type PaymentApiModelDataEnvelope = {
    Data?: PaymentApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type PaymentServiceApiModel = {
    readonly Name: string;
    readonly Url: string;
    readonly ImageUrl: string;
};

export type PaymentServiceApiModelListDataEnvelope = {
    Data?: Array<PaymentServiceApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum PaymentWorkflowType {
    NoPayment = 'NoPayment',
    ManualByHolder = 'ManualByHolder',
    ByUserBeforeEntering = 'ByUserBeforeEntering'
}

export enum PersonRelationshipType {
    Child = 'Child',
    Mother = 'Mother',
    Father = 'Father',
    Parent = 'Parent',
    Spouse = 'Spouse',
    Partner = 'Partner'
}

export type PhysicalLocationApiModel = {
    Id: number;
    ReceptionId: number;
    Address: string | null;
    Address2: string | null;
    PostalCode: string | null;
    City: string | null;
    Country: string | null;
    Name: string | null;
    Description: string | null;
    ImageUrl: string | null;
};

export type PhysicalLocationApiModelDataEnvelope = {
    Data?: PhysicalLocationApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type PhysicalLocationApiModelListDataEnvelope = {
    Data?: Array<PhysicalLocationApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type PresentingComplaint = {
    NodeId: number;
    Name: string;
};

export type PreviousOwnerInfo = {
    Name: string | null;
    ProfileImageUrl: string | null;
};

export type PrioritizedAppointmentType = {
    TicketId: string;
    Start: string;
    ActingHcp: CurrentAppointmentParticipant | null;
    ParticipantCount: number;
    ReceptionId: number;
    ReceptionName: string | null;
    UnitId: number;
    PhysicalLocationId: number | null;
};

export enum PrioritizedClientCaseDefinition {
    None = 'None',
    CurrentAppointment = 'CurrentAppointment',
    Unpaid = 'Unpaid',
    NewMessages = 'NewMessages',
    NewMessagesDifferentCases = 'NewMessagesDifferentCases',
    UnansweredForms = 'UnansweredForms',
    UpcomingAppointment = 'UpcomingAppointment'
}

export type PrioritizedClientCaseResultV2 = {
    Type: PrioritizedClientCaseDefinition;
    CurrentAppointment: PrioritizedAppointmentType | null;
    Unpaid: PrioritizedAppointmentType | null;
    NewMessage: CurrentMessagingUnread | null;
    NewMessagesDifferentCases: MultipleUnreadMessages | null;
    UpcomingAppointment: PrioritizedAppointmentType | null;
    UnansweredForms: CaseMissingFormResponses | null;
};

export type PrioritizedClientCaseResultV2DataEnvelope = {
    Data?: PrioritizedClientCaseResultV2 | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type ProblemDetails = {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
    [key: string]: unknown | (string | null) | (string | null) | (number | null) | (string | null) | (string | null) | undefined;
};

export enum QueryCommitStatus {
    JobNotFound = 'JobNotFound',
    Error = 'Error',
    CompletedOk = 'CompletedOk',
    Prepared = 'Prepared',
    InProgress = 'InProgress',
    WaitingForPickup = 'WaitingForPickup',
    PaymentRequired = 'PaymentRequired'
}

export type QuestionAnswerApiModel = {
    Id: number;
    BoolValue: boolean | null;
    Intvalue: number | null;
    StringValue: string | null;
    MultiOptions: Array<number>;
};

export type QuestionApiModel = {
    Id: number;
    SortValue: number;
    Header: string | null;
    Description: string | null;
    Type: FormQuestionType;
    Required: boolean;
    Placeholder: string | null;
    TrueLabel: string | null;
    FalseLabel: string | null;
    Options: Array<OptionApiModel>;
    Answer: QuestionAnswerApiModel | null;
};

export type RateApiModel = {
    Price: CurrencyDisplay;
    Tax: number;
    PaymentWorkflow: PaymentWorkflowType;
};

export type RateApiModelDataEnvelope = {
    Data?: RateApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type RebookWithNewTimeslotInput = {
    NewTimeslotId: string;
    ReschedulingReason?: string | null;
};

export type RecentVisitsApiModel = GuiComponentDataApiModel & {
    readonly Title?: string | null;
};

export type RecentlyVisitedReception = {
    ReceptionId: number;
    Name: string | null;
    Subtitle: string | null;
};

export type RecentlyVisitedReceptionIEnumerableDataEnvelope = {
    Data?: Array<RecentlyVisitedReception> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type ReceptionConditionDto = {
    Id: number;
    Name: string;
};

export enum ReceptionConditionInfoScreenFlow {
    None = 'None',
    Booking = 'Booking',
    DropIn = 'DropIn',
    Messaging = 'Messaging',
    Navigation = 'Navigation'
}

export type ReceptionPathEntity = {
    ReceptionId: number;
    UnitId: number;
    Name: string;
    Path: string;
    IsVisibleToClients: boolean;
};

export type ReceptionPathEntityListDataEnvelope = {
    Data?: Array<ReceptionPathEntity> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type ReceptionSearchApiModel = {
    readonly Id: number;
    readonly Name: string;
    readonly Subtitle: string | null;
    readonly Score: number;
    readonly Path: string;
};

export type ReceptionSearchApiModelIListDataEnvelope = {
    Data?: Array<ReceptionSearchApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type ReceptionVisitInput = {
    ReceptionId: number;
};

export type RepresentablePerson = {
    Id: string;
    Initials: string;
    CommonName: string;
    GivenName: string | null;
    Surname: string | null;
    IdentityCode: string;
    IdentityNumber: string;
    DateOfBirth: string | null;
    ListedAtReceptionId: number | null;
};

export type ResourceModel = {
    readonly Id: number;
    readonly Name: string | null;
    readonly Title: string | null;
    readonly DescriptiveTitle: string | null;
    readonly ProfileImageUrl: string | null;
};

export type RespondantApiModel = {
    readonly Id: number;
    readonly Answers: Array<AnswerApiModel>;
    readonly Completed: boolean;
    readonly CompletedTimestamp: string | null;
};

export type RespondantApiModelDataEnvelope = {
    Data?: RespondantApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type RespondantStatusApiModel = {
    RespondantId: number;
    FormId: number;
    Header: string | null;
    Opportunity: FormOpportunity;
    readonly Completed: boolean;
    CompletedTimestamp: string | null;
};

export type RuleSetHours = {
    IanaTimeZoneId: string;
    MonitoredHours: Array<MonitoredHours>;
    SpecialMonitoredHours: Array<SpecialMonitoredHours>;
};

export type RuleSetHoursDataEnvelope = {
    Data?: RuleSetHours | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum RuleSetType {
    TriageEntry = 'triageEntry',
    Navigation = 'navigation',
    Messaging = 'messaging'
}

export type SearchApiModel = GuiComponentDataApiModel & {
    readonly Title?: string | null;
};

export type SearchCapabilitiesApiModel = {
    Capabilities: Array<TimeslotSearchCapability>;
    Requirements: Array<TimeslotSearchCapability>;
    Resources: Array<FilterOption> | null;
    Conditions: Array<FilterOption> | null;
    Specialities: Array<FilterOption> | null;
    FilterableUnits: Array<FilterOption> | null;
};

export type SearchCapabilitiesApiModelDataEnvelope = {
    Data?: SearchCapabilitiesApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SearchLimitationResult = {
    FirstSearchDate: string | null;
    LastSearchDate: string | null;
    RelativeStart: string | null;
    RelativeEnd: string | null;
    HcpId: number | null;
    ForClientId: number | null;
    ForGuestId: number | null;
    PhysicalLocationId: number | null;
    Navigation: LimitationNavigation;
    NavigationBookingHandoff: NavigationBookingHandoffResult | null;
};

export type SessionExpirationInformationApiModel = {
    TouchExpiration: string;
    Expiration: string;
    LoginUrl: string | null;
    SuggestRefresh: boolean;
    MinutesRemaining: number;
};

export type SessionExpirationInformationApiModelDataEnvelope = {
    Data?: SessionExpirationInformationApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SetCloudMessagingTargetInput = {
    Type: CloudMessageTargetType;
    Target: string;
};

export type SetReasonArgs = {
    Reason?: string | null;
    ReasonFormat: TextFormat;
};

export type SignDocumentApiModel = {
    LanguageCode: string;
    Type: DocumentType;
};

export type SignOutApiModel = {
    RedirectUrl: string | null;
};

export type SignOutApiModelDataEnvelope = {
    Data?: SignOutApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SignableDocument = {
    HasSigned: boolean;
    Version: number;
    Language: string;
    Url: string;
    RequiresExplicitAccept: boolean;
    Title: string | null;
    Summary: string | null;
    Type: DocumentType;
};

export type Signatures = {
    PrivacyPolicy: SignableDocument;
    TermsOfService: SignableDocument;
};

export type SignaturesDataEnvelope = {
    Data?: Signatures | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type Slot = {
    OpeningTime: string;
    ClosingTime: string;
};

export type SlotUtc = {
    OpeningTime: string;
    ClosingTime: string;
};

export type SmsConfirmCodeApiResult = {
    RegistrationTicket: string | null;
};

export type SmsConfirmCodeApiResultDataEnvelope = {
    Data?: SmsConfirmCodeApiResult | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SmsStartAuthModel = {
    AttemptId: string;
};

export type SmsStartAuthModelDataEnvelope = {
    Data?: SmsStartAuthModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SpacerApiModel = GuiComponentDataApiModel & {
    Vertical?: SpacerSize | null;
    Horizontal?: SpacerSize | null;
};

export enum SpacerSize {
    XSmall = 'XSmall',
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large',
    XLarge = 'XLarge'
}

export type SpecialMonitoredHours = {
    Date: string;
    Open: string;
    Close: string | null;
};

export type StartNavigateRequest = {
    NavigateRequest: NavigateRequest;
    AsUnverifiedRepresentativeForNin?: string | null;
};

export type StartSessionInput = {
    LanguageCode: string;
    UserIsPatient: boolean;
    PatientNin?: string | null;
    DateOfBirth?: string | null;
    InformationGatheringSubmissionId?: string | null;
};

/**
 * Starts a Red Robin session for either the subject in the authenticated identity or an explicitly supplied unverified subject.
 */
export type StartSessionV2Input = {
    /**
     * The language to use in Red Robin.
     */
    LanguageCode: string;
    /**
     * The unverified subject's national identity number. Leave null to use the authenticated subject, which is the represented person
     * when verified representation is active and otherwise the signed-in person.
     */
    AsUnverifiedRepresentativeForNin?: string | null;
    /**
     * The unverified subject's date of birth when it cannot be derived from the national identity number.
     */
    DateOfBirth?: string | null;
    /**
     * An information-gathering submission that supplies the subject data. It cannot be combined with explicit unverified subject data.
     */
    InformationGatheringSubmissionId?: string | null;
};

/**
 * The result of successfully starting a Red Robin session.
 */
export type StartSessionV2Response = {
    /**
     * The URL where the patient enters the Red Robin session.
     */
    PatientEntryUrl: string;
};

export enum States {
    Unpaid = 'Unpaid',
    Paid = 'Paid',
    Expired = 'Expired'
}

export enum Status {
    Inactive = 'Inactive',
    Unavailable = 'Unavailable',
    Open = 'Open',
    Closed = 'Closed'
}

export type StringDataEnvelope = {
    Data?: string | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type StringObjectDictionaryDataEnvelope = {
    Data?: {
        [key: string]: unknown;
    } | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type StringStringDictionaryDataEnvelope = {
    Data?: {
        [key: string]: string | null;
    } | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type StringStringIReadOnlyDictionaryDataEnvelope = {
    Data?: {
        [key: string]: string | null;
    } | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SupportedCountryInfo = {
    CountryCode: string;
    ClientIdentifierNationalIdentityNumber: boolean;
    ClientIdentifierPhoneNumber: boolean;
    readonly Name: string;
};

export type SurveyAnswerApiModel = {
    Answers: Array<SurveyQuestionAnswerApiModel>;
    AppointmentTicket: string;
};

export enum SurveyAnswerValueType {
    Int4SatisfactionScore = 'Int4SatisfactionScore',
    Text500 = 'Text500'
}

export type SurveyApiModel = {
    Questions: Array<SurveyQuestionApiModel>;
};

export type SurveyApiModelDataEnvelope = {
    Data?: SurveyApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type SurveyQuestionAnswerApiModel = {
    Alias: string;
    IntValue: number | null;
    StringValue: string | null;
};

export type SurveyQuestionApiModel = {
    Id: number;
    Alias: string;
    Text: string | null;
    SortValue: number;
    Type: SurveyAnswerValueType;
};

export type TextApiModel = GuiComponentDataApiModel & {
    readonly Value?: string | null;
    Size: TextSize;
    Weight: TextWeight;
    readonly Color?: string | null;
};

export enum TextFormat {
    Plaintext = 'Plaintext',
    Markdown = 'Markdown'
}

export enum TextSize {
    SmallBody = 'SmallBody',
    Body = 'Body',
    LargeBody = 'LargeBody',
    SmallTitle = 'SmallTitle',
    Title = 'Title'
}

export enum TextWeight {
    Regular = 'Regular',
    Semibold = 'Semibold',
    Bold = 'Bold'
}

export type TimeslotApiModel = {
    Id: string;
    Name: string | null;
    Start: string;
    Duration: number;
    readonly UnbookableAfter: string;
    RequiresPayment: boolean;
    Price: CurrencyDisplay | null;
    Resource: ResourceModel;
    PhysicalLocationId: number | null;
};

export type TimeslotApiModelDataEnvelope = {
    Data?: TimeslotApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type TimeslotApiModelListDataEnvelope = {
    Data?: Array<TimeslotApiModel> | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type TimeslotAvailabilityApiModel = {
    /**
     * Indicates whether the specified timeslot type is supported at all.
     */
    Supported: boolean;
    /**
     * The start time of the first available timeslot of the specified type.
     */
    FirstAvailableUpcomingTime: string | null;
};

export type TimeslotAvailabilityCountsApiModel = {
    AvailableDates: Array<DateCountPairApiModel>;
    NextAvailableDate: string | null;
};

export type TimeslotAvailabilityCountsApiModelDataEnvelope = {
    Data?: TimeslotAvailabilityCountsApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type TimeslotAvailabilityGroupingApiModel = {
    Digital: TimeslotAvailabilityApiModel;
    PhysicalLocations: {
        [key: string]: TimeslotAvailabilityApiModel;
    };
};

export type TimeslotAvailabilityGroupingApiModelDataEnvelope = {
    Data?: TimeslotAvailabilityGroupingApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type TimeslotLockApiModel = {
    Id: string;
    ValidUntil: string;
};

export type TimeslotLockApiModelDataEnvelope = {
    Data?: TimeslotLockApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum TimeslotSearchCapability {
    DateFrom = 'DateFrom',
    DateTo = 'DateTo',
    TimeFrom = 'TimeFrom',
    TimeTo = 'TimeTo',
    ResourceId = 'ResourceId',
    ResourceSpecialityId = 'ResourceSpecialityId',
    ResourceConditionId = 'ResourceConditionId',
    ResourceUnitId = 'ResourceUnitId'
}

export enum UiTemplate {
    Open = 'Open',
    OpensToday = 'OpensToday',
    OpensTomorrow = 'OpensTomorrow',
    OpensWeekday = 'OpensWeekday',
    Closed = 'Closed',
    ClosesToday = 'ClosesToday'
}

export type Unit = {
    UnitId: number;
    Name: string;
    Subtitle: string | null;
    Path: string;
};

export type UnitAboutApiModel = {
    Info: string | null;
    Phone: string | null;
    Email: string | null;
    Url: string | null;
    UrlLinkName: string | null;
    VisitAddress: AddressModel | null;
    Coordinates: CoordinatesModel | null;
};

export type UnitAboutApiModelDataEnvelope = {
    Data?: UnitAboutApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type UnitConfigApiModel = {
    Unit: Unit;
    Offer: Offer | null;
    Locale: Locale;
    AppConfig: AppConfigInfo | null;
    LicenceHolder: Licenceholder;
    Translations: {
        [key: string]: string | null;
    };
    Theme: {
        [key: string]: unknown;
    };
    WebContentButtons: Array<WebContentButtonApiModel>;
    ReceptionId: number | null;
    TermsOfServiceUrl: string;
    PrivacyPolicyUrl: string;
};

export type UnitConfigApiModelDataEnvelope = {
    Data?: UnitConfigApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type UnitModel = {
    Id: number;
    ParentId: number | null;
    Name: string | null;
    Subtitle: string | null;
    UrlAlias: string;
    IsClientEntrance: boolean;
    IsListedToClients: boolean;
    ReceptionId: number | null;
    IAmListedHere: boolean;
    Children: Array<UnitModel>;
};

export type UnitModelDataEnvelope = {
    Data?: UnitModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export type UpdateIdentityApiInput = {
    FirstName?: string | null;
    LastName?: string | null;
    Email?: string | null;
    Phone?: string | null;
    NationalIdentityNumber?: string | null;
    Nationality?: string | null;
    PhoneVerificationAttemptId?: string | null;
    DocumentSignatures?: Array<SignDocumentApiModel> | null;
    NotificationComplianceSettings?: UpdateNotificationComplianceSettingsApiModel | null;
};

export type UpdateLegalGuardiansApiInput = {
    /**
     * The desired list of legal guardians invited to the appointment. Replace semantics: any guardian
     * participant currently on the booking that is not in this list will be uninvited; any guardian in
     * this list that is not currently invited will be added as a participant.
     */
    LegalGuardians: Array<LegalGuardianInput>;
};

export type UpdateNotificationComplianceSettingsApiModel = {
    AllowEmail: boolean;
    AllowSms: boolean;
};

export type UserFileApiInput = {
    Name?: string | null;
    Length: number;
    Type?: string | null;
    readonly IsValid: boolean;
};

export type UserFileApiModel = {
    Id: string;
    DownloadUrl: string;
    UploadUrl: string;
    DeleteUrl: string;
    ThumbnailUrl: string | null;
};

export type UserFileApiModelDataEnvelope = {
    Data?: UserFileApiModel | null;
    Successful: boolean;
    ErrorCode?: string | null;
    ErrorMessage?: string | null;
    ValidationErrors?: {
        [key: string]: Array<string>;
    } | null;
};

export enum UserType {
    Client = 'Client',
    Outsider = 'Outsider'
}

export enum ValidationResultType {
    SystemError = 'SystemError',
    FormMissingResponse = 'FormMissingResponse',
    RecreateProduct = 'RecreateProduct',
    NoProducts = 'NoProducts',
    Ok = 'Ok',
    JustOneProduct = 'JustOneProduct'
}

export type WebContentButtonApiModel = {
    Id: number;
    ReceptionId: number;
    IconUrl: string;
    HasBrandedNavbar: boolean;
    RequiresAuthentication: boolean;
    IsActive: boolean;
    OpenUrlWith: OpenUrlWith;
    Translations: Array<WebContentButtonTranslationApiModel>;
};

export type WebContentButtonTranslationApiModel = {
    LanguageCode: string | null;
    Title: string | null;
    Url: string | null;
    IsAppDeepLink: boolean;
};

/**
 * Result returned when a messaging conversation product is added to the basket.
 */
export type AddMessagingConversationResultWritable = {
    /**
     * The identifier of the created basket product.
     */
    BasketProductId: number;
    /**
     * Validation status for submitted form answers, keyed by form id.
     */
    AnswerStatus: {
        [key: string]: Array<AnswerFormQuestionUpdateResult>;
    };
    /**
     * Overall validation result for the product.
     */
    ValidationResult: ValidationResultType;
    /**
     * Resolved participants (patient and legal guardians) for representative flows. Empty when not representing.
     */
    Participants: Array<BasketParticipantApiModel>;
};

export type AppointmentApiModelWritable = {
    BookingId: number;
    ResourceId: number | null;
    Ticket: string;
    UnitId: number;
    ReceptionId: number;
    Role: BookingParticipantRole;
    IsMainSubject: boolean;
    Start: string;
    Duration: number;
    Reason: string | null;
    AsAgentFor: string | null;
    AsAgentForName: string | null;
    PerformMediaTest: boolean;
    /**
     * Indicates whether this appointment has been previously seen by the user or not.
     */
    HasSeen: boolean;
    MyParticipant: ParticipantModel;
    OtherParticipants: Array<ParticipantModel>;
    ReservedUntil: string | null;
    Reserved: boolean;
    Cancelable: boolean;
    Reschedulable: boolean;
    CompletedTimestamp: string | null;
    Condition: ClientConditionApiModelWritable | null;
    InitialSymptoms: Array<string> | null;
    Price?: unknown;
    Payment: PaymentApiModel | null;
    Files: Array<FileApiModel>;
    Forms: Array<RespondantStatusApiModelWritable>;
    CompletedRedirectUrl: string | null;
    PhysicalLocationId: number | null;
    Source: BookingSource;
    VonageEncryptionRequired: boolean;
    VonageProxyUrl: string | null;
};

export type ButtonIconApiModelWritable = {
    Subtitle: string | null;
};

export type CaseApiModelWritable = {
    Cancelable: boolean;
    Reschedulable: boolean;
};

export type CasePaymentInformationWritable = {
    Amount: number;
    Currency: string;
};

export type CaseResourceDtoWritable = {
    FirstName: string;
    LastName: string;
    Title: string | null;
};

export type ClientConditionApiModelWritable = {
    Name: string | null;
    InfoScreen: ConditionInfoScreenApiModel | null;
};

export type ClientPersonalizedCaseApiModelWritable = {
    Id: number;
    ReceptionId: number;
    Reason: string | null;
    ReasonFormat: TextFormat;
    Condition: ReceptionConditionDto | null;
    TimeZoneInfo: string;
    CreatedTimestamp: string;
    StartedTimestamp: string | null;
    CompletedTimestamp: string | null;
    LastMessageTimestamp: string | null;
    HasReadUntilTimestamp: string | null;
    UnreadMessages: number;
    HasFiles: boolean;
    AllowClientResponse: boolean;
    PaymentInfo: CasePaymentInformationWritable | null;
    ResourceInfo: CaseResourceDtoWritable | null;
};

export type DropInApiModelWritable = {
    Id: number;
    Name: string;
    Description: string | null;
    InQueueText: string | null;
    UrlAlias: string;
    AllowsGuests: boolean;
    /**
     * @deprecated
     */
    OpenHours: Array<Day>;
    OpenHoursUtc: Array<DayUtc>;
    IsOpen: boolean;
    CurrentWaitTime: number;
    MinimumShownWaitTime: number;
    HandshakeTimeout: number;
    RequiresPayment: boolean;
    TicketPrice?: unknown;
};

export type GuiComponentApiModelWritable = {
    [key: string]: unknown;
};

export type ListApiModelWritable = GuiComponentDataApiModel & {};

export type ListDirectionalApiModelWritable = ListApiModelWritable & {};

export type MessagingCaseCommittedApiModelWritable = {
    Id: number;
};

export type MessagingConversationApiModelWritable = {
    Forms: Array<RespondantStatusApiModelWritable>;
};

export type PaymentServiceApiModelListDataEnvelopeWritable = {
    Data: Array<unknown> | null;
    Successful: boolean;
    ErrorCode: string | null;
    ErrorMessage: string | null;
    ValidationErrors: {
        [key: string]: Array<string>;
    } | null;
};

export type PrioritizedClientCaseResultV2Writable = {
    Type: PrioritizedClientCaseDefinition;
    Unpaid: PrioritizedAppointmentType | null;
    NewMessage: CurrentMessagingUnread | null;
    UpcomingAppointment: PrioritizedAppointmentType | null;
};

export type RateApiModelWritable = {
    Price: unknown;
    Tax: number;
    PaymentWorkflow: PaymentWorkflowType;
};

export type ReceptionSearchApiModelIListDataEnvelopeWritable = {
    Data: Array<unknown> | null;
    Successful: boolean;
    ErrorCode: string | null;
    ErrorMessage: string | null;
    ValidationErrors: {
        [key: string]: Array<string>;
    } | null;
};

export type RespondantApiModelWritable = {
    [key: string]: unknown;
};

export type RespondantStatusApiModelWritable = {
    RespondantId: number;
    FormId: number;
    Header: string | null;
    Opportunity: FormOpportunity;
    CompletedTimestamp: string | null;
};

export type SupportedCountryInfoWritable = {
    CountryCode: string;
    ClientIdentifierNationalIdentityNumber: boolean;
    ClientIdentifierPhoneNumber: boolean;
};

export type TimeslotApiModelWritable = {
    Id: string;
    Name: string | null;
    Start: string;
    Duration: number;
    RequiresPayment: boolean;
    Price?: unknown;
    Resource: unknown;
    PhysicalLocationId: number | null;
};

export type UserFileApiInputWritable = {
    Name: string | null;
    Length: number;
    Type: string | null;
};

export type AppConfigGetData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/AppConfig';
};

export type AppConfigGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type AppConfigGetError = AppConfigGetErrors[keyof AppConfigGetErrors];

export type AppConfigGetResponses = {
    /**
     * OK
     */
    200: AppConfigInfoDataEnvelope;
};

export type AppConfigGetResponse = AppConfigGetResponses[keyof AppConfigGetResponses];

export type BasketDeleteActiveBasketData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/Active/{receptionId}';
};

export type BasketDeleteActiveBasketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketDeleteActiveBasketError = BasketDeleteActiveBasketErrors[keyof BasketDeleteActiveBasketErrors];

export type BasketDeleteActiveBasketResponses = {
    /**
     * OK
     */
    200: DeleteBasketApiResultDataEnvelope;
};

export type BasketDeleteActiveBasketResponse = BasketDeleteActiveBasketResponses[keyof BasketDeleteActiveBasketResponses];

export type BasketGetActiveBasketData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/Active/{receptionId}';
};

export type BasketGetActiveBasketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketGetActiveBasketError = BasketGetActiveBasketErrors[keyof BasketGetActiveBasketErrors];

export type BasketGetActiveBasketResponses = {
    /**
     * OK
     */
    200: Int32DataEnvelope;
};

export type BasketGetActiveBasketResponse = BasketGetActiveBasketResponses[keyof BasketGetActiveBasketResponses];

export type BasketDeleteBasketData = {
    body?: never;
    path: {
        basketId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}';
};

export type BasketDeleteBasketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketDeleteBasketError = BasketDeleteBasketErrors[keyof BasketDeleteBasketErrors];

export type BasketDeleteBasketResponses = {
    /**
     * OK
     */
    200: DeleteBasketApiResultDataEnvelope;
};

export type BasketDeleteBasketResponse = BasketDeleteBasketResponses[keyof BasketDeleteBasketResponses];

export type BasketGetBasketData = {
    body?: never;
    path: {
        basketId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}';
};

export type BasketGetBasketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketGetBasketError = BasketGetBasketErrors[keyof BasketGetBasketErrors];

export type BasketGetBasketResponses = {
    /**
     * OK
     */
    200: BasketContentsApiModelDataEnvelope;
};

export type BasketGetBasketResponse = BasketGetBasketResponses[keyof BasketGetBasketResponses];

export type BasketAddMessagingProductData = {
    /**
     * The messaging conversation configuration.
     */
    body?: MessagingConversationInput;
    path: {
        basketId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/MessagingConversation';
};

export type BasketAddMessagingProductErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketAddMessagingProductError = BasketAddMessagingProductErrors[keyof BasketAddMessagingProductErrors];

export type BasketAddMessagingProductResponses = {
    /**
     * OK
     */
    200: AddMessagingConversationResultDataEnvelope;
};

export type BasketAddMessagingProductResponse = BasketAddMessagingProductResponses[keyof BasketAddMessagingProductResponses];

export type BasketSelectParticipantData = {
    body?: never;
    path: {
        basketId: number;
        basketProductId: number;
        participantId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Products/{basketProductId}/Participants/{participantId}/select';
};

export type BasketSelectParticipantErrors = {
    /**
     * The basket, product, or participant was not found.
     */
    404: unknown;
};

export type BasketSelectParticipantResponses = {
    /**
     * The participant was selected successfully.
     */
    204: void;
};

export type BasketSelectParticipantResponse = BasketSelectParticipantResponses[keyof BasketSelectParticipantResponses];

export type BasketDeselectParticipantData = {
    body?: never;
    path: {
        basketId: number;
        basketProductId: number;
        participantId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Products/{basketProductId}/Participants/{participantId}/deselect';
};

export type BasketDeselectParticipantErrors = {
    /**
     * The basket, product, or participant was not found.
     */
    404: unknown;
};

export type BasketDeselectParticipantResponses = {
    /**
     * The participant was deselected successfully.
     */
    204: void;
};

export type BasketDeselectParticipantResponse = BasketDeselectParticipantResponses[keyof BasketDeselectParticipantResponses];

export type BasketDeleteFilesData = {
    body?: never;
    path: {
        basketId: number;
        basketItemId: number;
    };
    query?: {
        /**
         * The file identifiers to remove.
         */
        fid?: Array<string>;
    };
    url: '/api/Client/v2/Baskets/{basketId}/Item/{basketItemId}/Files';
};

export type BasketDeleteFilesErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketDeleteFilesError = BasketDeleteFilesErrors[keyof BasketDeleteFilesErrors];

export type BasketDeleteFilesResponses = {
    /**
     * OK
     */
    200: DeleteFilesResultApiModelDataEnvelope;
};

export type BasketDeleteFilesResponse = BasketDeleteFilesResponses[keyof BasketDeleteFilesResponses];

export type BasketAddFilesData = {
    /**
     * The file references to add.
     */
    body: Array<BasketFileReferenceInput>;
    path: {
        basketId: number;
        basketItemId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Item/{basketItemId}/Files';
};

export type BasketAddFilesErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketAddFilesError = BasketAddFilesErrors[keyof BasketAddFilesErrors];

export type BasketAddFilesResponses = {
    /**
     * OK
     */
    200: FileMapResultListDataEnvelope;
};

export type BasketAddFilesResponse = BasketAddFilesResponses[keyof BasketAddFilesResponses];

export type BasketGetExternalDataData = {
    body?: never;
    path: {
        basketId: number;
        basketProductId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Item/{basketProductId}/ExternalData';
};

export type BasketGetExternalDataErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketGetExternalDataError = BasketGetExternalDataErrors[keyof BasketGetExternalDataErrors];

export type BasketGetExternalDataResponses = {
    /**
     * OK
     */
    200: ExternalDataResultDataEnvelope;
};

export type BasketGetExternalDataResponse = BasketGetExternalDataResponses[keyof BasketGetExternalDataResponses];

export type BasketSetExternalDataData = {
    /**
     * The external data reference identifiers.
     */
    body: Array<string>;
    path: {
        basketId: number;
        basketProductId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Item/{basketProductId}/ExternalData';
};

export type BasketSetExternalDataErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketSetExternalDataError = BasketSetExternalDataErrors[keyof BasketSetExternalDataErrors];

export type BasketSetExternalDataResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type BasketSetExternalDataResponse = BasketSetExternalDataResponses[keyof BasketSetExternalDataResponses];

export type BasketSetReasonData = {
    /**
     * The reason text and format.
     */
    body: SetReasonArgs;
    path: {
        basketId: number;
        basketItemId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Item/{basketItemId}/Reason';
};

export type BasketSetReasonErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketSetReasonError = BasketSetReasonErrors[keyof BasketSetReasonErrors];

export type BasketSetReasonResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type BasketSetReasonResponse = BasketSetReasonResponses[keyof BasketSetReasonResponses];

export type BasketRemoveItemsData = {
    body?: never;
    path: {
        basketId: number;
        basketItemId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Items/{basketItemId}';
};

export type BasketRemoveItemsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketRemoveItemsError = BasketRemoveItemsErrors[keyof BasketRemoveItemsErrors];

export type BasketRemoveItemsResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type BasketRemoveItemsResponse = BasketRemoveItemsResponses[keyof BasketRemoveItemsResponses];

export type BasketGetFormAnswersData = {
    body?: never;
    path: {
        basketId: number;
        basketProductId: number;
        formId: number;
    };
    query?: {
        /**
         * Optional filter to return only specific question ids.
         */
        qid?: Array<number>;
    };
    url: '/api/Client/v2/Baskets/{basketId}/FormAnswers/{basketProductId}/{formId}';
};

export type BasketGetFormAnswersErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketGetFormAnswersError = BasketGetFormAnswersErrors[keyof BasketGetFormAnswersErrors];

export type BasketGetFormAnswersResponses = {
    /**
     * OK
     */
    200: FormQuestionAnswerListDataEnvelope;
};

export type BasketGetFormAnswersResponse = BasketGetFormAnswersResponses[keyof BasketGetFormAnswersResponses];

export type BasketSetFormAnswersData = {
    /**
     * The form question answers.
     */
    body: Array<BasketFormAnswer>;
    path: {
        basketId: number;
        basketProductId: number;
        formId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/FormAnswers/{basketProductId}/{formId}';
};

export type BasketSetFormAnswersErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketSetFormAnswersError = BasketSetFormAnswersErrors[keyof BasketSetFormAnswersErrors];

export type BasketSetFormAnswersResponses = {
    /**
     * OK
     */
    200: AnswerFormQuestionUpdateResultListDataEnvelope;
};

export type BasketSetFormAnswersResponse = BasketSetFormAnswersResponses[keyof BasketSetFormAnswersResponses];

export type BasketPreCommitData = {
    body?: never;
    path: {
        basketId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/PreCommit';
};

export type BasketPreCommitErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketPreCommitError = BasketPreCommitErrors[keyof BasketPreCommitErrors];

export type BasketPreCommitResponses = {
    /**
     * OK
     */
    200: CommitResultDataEnvelope;
};

export type BasketPreCommitResponse = BasketPreCommitResponses[keyof BasketPreCommitResponses];

export type BasketDeleteCommitData = {
    body?: never;
    path: {
        commitJobId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/Commit/{commitJobId}';
};

export type BasketDeleteCommitErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketDeleteCommitError = BasketDeleteCommitErrors[keyof BasketDeleteCommitErrors];

export type BasketDeleteCommitResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type BasketDeleteCommitResponse = BasketDeleteCommitResponses[keyof BasketDeleteCommitResponses];

export type BasketCommitStatusQueryCommitStatusActionData = {
    body?: never;
    path: {
        commitJobId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/Commit/{commitJobId}';
};

export type BasketCommitStatusQueryCommitStatusActionErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketCommitStatusQueryCommitStatusActionError = BasketCommitStatusQueryCommitStatusActionErrors[keyof BasketCommitStatusQueryCommitStatusActionErrors];

export type BasketCommitStatusQueryCommitStatusActionResponses = {
    /**
     * OK
     */
    200: CommitSuccessResultDataEnvelope;
};

export type BasketCommitStatusQueryCommitStatusActionResponse = BasketCommitStatusQueryCommitStatusActionResponses[keyof BasketCommitStatusQueryCommitStatusActionResponses];

export type BasketContinueCommitData = {
    body?: never;
    path: {
        commitJobId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/Commit/{commitJobId}';
};

export type BasketContinueCommitErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketContinueCommitError = BasketContinueCommitErrors[keyof BasketContinueCommitErrors];

export type BasketContinueCommitResponses = {
    /**
     * OK
     */
    200: CommitResultDataEnvelope;
};

export type BasketContinueCommitResponse = BasketContinueCommitResponses[keyof BasketContinueCommitResponses];

export type BasketCreateCommitData = {
    body?: never;
    path: {
        basketId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/Commit';
};

export type BasketCreateCommitErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketCreateCommitError = BasketCreateCommitErrors[keyof BasketCreateCommitErrors];

export type BasketCreateCommitResponses = {
    /**
     * OK
     */
    200: CommitResultDataEnvelope;
};

export type BasketCreateCommitResponse = BasketCreateCommitResponses[keyof BasketCreateCommitResponses];

export type BasketCreateCommitOldData = {
    body?: never;
    path: {
        basketId: number;
    };
    query?: never;
    url: '/api/Client/v2/Baskets/{basketId}/CreateCommit';
};

export type BasketCreateCommitOldErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type BasketCreateCommitOldError = BasketCreateCommitOldErrors[keyof BasketCreateCommitOldErrors];

export type BasketCreateCommitOldResponses = {
    /**
     * OK
     */
    200: Int64DataEnvelope;
};

export type BasketCreateCommitOldResponse = BasketCreateCommitOldResponses[keyof BasketCreateCommitOldResponses];

export type CareCompanionCreateSessionData = {
    body?: CareCompanionSessionRequestApiModel;
    path?: never;
    query?: never;
    url: '/api/Client/v2/CareCompanion/Session';
};

export type CareCompanionCreateSessionErrors = {
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Unprocessable Content
     */
    422: ProblemDetails;
    /**
     * Bad Gateway
     */
    502: ProblemDetails;
    /**
     * Service Unavailable
     */
    503: ProblemDetails;
};

export type CareCompanionCreateSessionError = CareCompanionCreateSessionErrors[keyof CareCompanionCreateSessionErrors];

export type CareCompanionCreateSessionResponses = {
    /**
     * OK
     */
    200: CareCompanionSessionApiModel;
};

export type CareCompanionCreateSessionResponse = CareCompanionCreateSessionResponses[keyof CareCompanionCreateSessionResponses];

export type CareCompanionEndSessionData = {
    body?: never;
    path: {
        sessionId: string;
    };
    query?: never;
    url: '/api/Client/v2/CareCompanion/Session/{sessionId}';
};

export type CareCompanionEndSessionErrors = {
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Bad Gateway
     */
    502: ProblemDetails;
    /**
     * Service Unavailable
     */
    503: ProblemDetails;
};

export type CareCompanionEndSessionError = CareCompanionEndSessionErrors[keyof CareCompanionEndSessionErrors];

export type CareCompanionEndSessionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CareCompanionEndSessionResponse = CareCompanionEndSessionResponses[keyof CareCompanionEndSessionResponses];

export type PrivacyPolicyWebInfoData = {
    body?: never;
    path: {
        platform: AppPlatform;
        appIdentifier: string;
    };
    query?: never;
    url: '/api/Client/v2/App/{platform}/{appIdentifier}/WebInfo';
};

export type PrivacyPolicyWebInfoErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type PrivacyPolicyWebInfoError = PrivacyPolicyWebInfoErrors[keyof PrivacyPolicyWebInfoErrors];

export type PrivacyPolicyWebInfoResponses = {
    /**
     * OK
     */
    200: AppWebInfoApiModelDataEnvelope;
};

export type PrivacyPolicyWebInfoResponse = PrivacyPolicyWebInfoResponses[keyof PrivacyPolicyWebInfoResponses];

export type ClientAppPointToPrivacyPolicyData = {
    body?: never;
    path: {
        platform: AppPlatform;
        appIdentifier: string;
    };
    query?: {
        langcode?: string;
    };
    url: '/api/Client/v2/App/{platform}/{appIdentifier}/PrivacyPolicy';
};

export type ClientAppPointToPrivacyPolicyResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type ClientAppPointToTermsOfServiceData = {
    body?: never;
    path: {
        platform: AppPlatform;
        appIdentifier: string;
    };
    query?: {
        langcode?: string;
    };
    url: '/api/Client/v2/App/{platform}/{appIdentifier}/TermsOfService';
};

export type ClientAppPointToTermsOfServiceResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type ClientAppGetConfigData = {
    body?: never;
    path: {
        platform: AppPlatform;
        appIdentifier: string;
    };
    query?: never;
    url: '/api/Client/v2/App/{platform}/{appIdentifier}';
};

export type ClientAppGetConfigErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppGetConfigError = ClientAppGetConfigErrors[keyof ClientAppGetConfigErrors];

export type ClientAppGetConfigResponses = {
    /**
     * OK
     */
    200: AppConfigApiModelDataEnvelope;
};

export type ClientAppGetConfigResponse = ClientAppGetConfigResponses[keyof ClientAppGetConfigResponses];

export type ClientAppointmentsGetUpcomingAndUnfinishedData = {
    body?: never;
    path?: never;
    query?: {
        withUnfinishedforms?: boolean;
    };
    url: '/api/Client/v2/Appointments';
};

export type ClientAppointmentsGetUpcomingAndUnfinishedErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsGetUpcomingAndUnfinishedError = ClientAppointmentsGetUpcomingAndUnfinishedErrors[keyof ClientAppointmentsGetUpcomingAndUnfinishedErrors];

export type ClientAppointmentsGetUpcomingAndUnfinishedResponses = {
    /**
     * OK
     */
    200: AppointmentApiModelListDataEnvelope;
};

export type ClientAppointmentsGetUpcomingAndUnfinishedResponse = ClientAppointmentsGetUpcomingAndUnfinishedResponses[keyof ClientAppointmentsGetUpcomingAndUnfinishedResponses];

export type ClientAppointmentsCancelData = {
    body?: CancelAppointmentInput;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/Appointments/{ticket}';
};

export type ClientAppointmentsCancelErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsCancelError = ClientAppointmentsCancelErrors[keyof ClientAppointmentsCancelErrors];

export type ClientAppointmentsCancelResponses = {
    /**
     * OK
     */
    200: CancelBookingApiResultDataEnvelope;
};

export type ClientAppointmentsCancelResponse = ClientAppointmentsCancelResponses[keyof ClientAppointmentsCancelResponses];

export type ClientAppointmentsGetData = {
    body?: never;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/Appointments/{ticket}';
};

export type ClientAppointmentsGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsGetError = ClientAppointmentsGetErrors[keyof ClientAppointmentsGetErrors];

export type ClientAppointmentsGetResponses = {
    /**
     * OK
     */
    200: AppointmentApiModelDataEnvelope;
};

export type ClientAppointmentsGetResponse = ClientAppointmentsGetResponses[keyof ClientAppointmentsGetResponses];

export type ClientAppointmentsGetCallStatusData = {
    body?: never;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/Appointments/{ticket}/CallStatus';
};

export type ClientAppointmentsGetCallStatusErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsGetCallStatusError = ClientAppointmentsGetCallStatusErrors[keyof ClientAppointmentsGetCallStatusErrors];

export type ClientAppointmentsGetCallStatusResponses = {
    /**
     * OK
     */
    200: CallStatusApiModelDataEnvelope;
};

export type ClientAppointmentsGetCallStatusResponse = ClientAppointmentsGetCallStatusResponses[keyof ClientAppointmentsGetCallStatusResponses];

export type ClientAppointmentsDeclineData = {
    body?: never;
    path: {
        bookingId: number;
    };
    query?: never;
    url: '/api/Client/v2/Appointments/Decline/{bookingId}';
};

export type ClientAppointmentsDeclineErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsDeclineError = ClientAppointmentsDeclineErrors[keyof ClientAppointmentsDeclineErrors];

export type ClientAppointmentsDeclineResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientAppointmentsDeclineResponse = ClientAppointmentsDeclineResponses[keyof ClientAppointmentsDeclineResponses];

export type ClientAppointmentsUpdateLegalGuardiansData = {
    body?: UpdateLegalGuardiansApiInput;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/Appointments/{ticket}/LegalGuardians';
};

export type ClientAppointmentsUpdateLegalGuardiansErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsUpdateLegalGuardiansError = ClientAppointmentsUpdateLegalGuardiansErrors[keyof ClientAppointmentsUpdateLegalGuardiansErrors];

export type ClientAppointmentsUpdateLegalGuardiansResponses = {
    /**
     * OK
     */
    200: AppointmentApiModelDataEnvelope;
};

export type ClientAppointmentsUpdateLegalGuardiansResponse = ClientAppointmentsUpdateLegalGuardiansResponses[keyof ClientAppointmentsUpdateLegalGuardiansResponses];

export type ClientAppointmentsAddFileData = {
    body?: UserFileApiInputWritable;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/Appointments/{ticket}/files';
};

export type ClientAppointmentsAddFileErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAppointmentsAddFileError = ClientAppointmentsAddFileErrors[keyof ClientAppointmentsAddFileErrors];

export type ClientAppointmentsAddFileResponses = {
    /**
     * OK
     */
    200: FileUploadApiModelDataEnvelope;
};

export type ClientAppointmentsAddFileResponse = ClientAppointmentsAddFileResponses[keyof ClientAppointmentsAddFileResponses];

export type ClientAuthMethodsGetAuthMethodsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        device?: string;
        countryCode?: string;
        returnUrl?: string;
        usage?: AuthMethodUsage;
    };
    url: '/api/Client/v2/units/{unitId}/Auth/Methods';
};

export type ClientAuthMethodsGetAuthMethodsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientAuthMethodsGetAuthMethodsError = ClientAuthMethodsGetAuthMethodsErrors[keyof ClientAuthMethodsGetAuthMethodsErrors];

export type ClientAuthMethodsGetAuthMethodsResponses = {
    /**
     * OK
     */
    200: AuthMethodApiModelListDataEnvelope;
};

export type ClientAuthMethodsGetAuthMethodsResponse = ClientAuthMethodsGetAuthMethodsResponses[keyof ClientAuthMethodsGetAuthMethodsResponses];

export type ClientBookableTimeLocksCreateLockData = {
    body?: never;
    path: {
        unitId: number;
        timeslotId: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/timeslots/{timeslotId}/locks';
};

export type ClientBookableTimeLocksCreateLockErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientBookableTimeLocksCreateLockError = ClientBookableTimeLocksCreateLockErrors[keyof ClientBookableTimeLocksCreateLockErrors];

export type ClientBookableTimeLocksCreateLockResponses = {
    /**
     * OK
     */
    200: TimeslotLockApiModelDataEnvelope;
};

export type ClientBookableTimeLocksCreateLockResponse = ClientBookableTimeLocksCreateLockResponses[keyof ClientBookableTimeLocksCreateLockResponses];

export type ClientBookableTimeLocksReleaseLockData = {
    body?: never;
    path: {
        unitId: number;
        bookableTimeLockId: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/timeslotlocks/{bookableTimeLockId}';
};

export type ClientBookableTimeLocksReleaseLockErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientBookableTimeLocksReleaseLockError = ClientBookableTimeLocksReleaseLockErrors[keyof ClientBookableTimeLocksReleaseLockErrors];

export type ClientBookableTimeLocksReleaseLockResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientBookableTimeLocksReleaseLockResponse = ClientBookableTimeLocksReleaseLockResponses[keyof ClientBookableTimeLocksReleaseLockResponses];

export type ClientBookableTimeLocksExtendLockData = {
    body?: never;
    path: {
        unitId: number;
        bookableTimeLockId: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/timeslotlocks/{bookableTimeLockId}';
};

export type ClientBookableTimeLocksExtendLockErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientBookableTimeLocksExtendLockError = ClientBookableTimeLocksExtendLockErrors[keyof ClientBookableTimeLocksExtendLockErrors];

export type ClientBookableTimeLocksExtendLockResponses = {
    /**
     * OK
     */
    200: TimeslotLockApiModelDataEnvelope;
};

export type ClientBookableTimeLocksExtendLockResponse = ClientBookableTimeLocksExtendLockResponses[keyof ClientBookableTimeLocksExtendLockResponses];

export type ClientCasesListUpdatesData = {
    body?: never;
    path?: never;
    query?: {
        from?: string;
        to?: string;
    };
    url: '/api/Client/v2/Cases';
};

export type ClientCasesListUpdatesErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientCasesListUpdatesError = ClientCasesListUpdatesErrors[keyof ClientCasesListUpdatesErrors];

export type ClientCasesListUpdatesResponses = {
    /**
     * OK
     */
    200: CaseApiModelListDataEnvelope;
};

export type ClientCasesListUpdatesResponse = ClientCasesListUpdatesResponses[keyof ClientCasesListUpdatesResponses];

export type ClientCasesMarkNewAppointmentSeenData = {
    body?: never;
    path: {
        callTicket: string;
    };
    query?: never;
    url: '/api/Client/v2/Cases/newincoming/appointment/{callTicket}';
};

export type ClientCasesMarkNewAppointmentSeenErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientCasesMarkNewAppointmentSeenError = ClientCasesMarkNewAppointmentSeenErrors[keyof ClientCasesMarkNewAppointmentSeenErrors];

export type ClientCasesMarkNewAppointmentSeenResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientCasesMarkNewAppointmentSeenResponse = ClientCasesMarkNewAppointmentSeenResponses[keyof ClientCasesMarkNewAppointmentSeenResponses];

export type ClientCasesPrioritizedV2Data = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Cases/v2/prioritized';
};

export type ClientCasesPrioritizedV2Errors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientCasesPrioritizedV2Error = ClientCasesPrioritizedV2Errors[keyof ClientCasesPrioritizedV2Errors];

export type ClientCasesPrioritizedV2Responses = {
    /**
     * OK
     */
    200: PrioritizedClientCaseResultV2DataEnvelope;
};

export type ClientCasesPrioritizedV2Response = ClientCasesPrioritizedV2Responses[keyof ClientCasesPrioritizedV2Responses];

export type ClientConditionsListData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Conditions';
};

export type ClientConditionsListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientConditionsListError = ClientConditionsListErrors[keyof ClientConditionsListErrors];

export type ClientConditionsListResponses = {
    /**
     * OK
     */
    200: ClientConditionApiModelListDataEnvelope;
};

export type ClientConditionsListResponse = ClientConditionsListResponses[keyof ClientConditionsListResponses];

export type ClientDropInEnqueueData = {
    body?: DropInEnqueueApiModel;
    path: {
        dropInRoomId: number;
    };
    query?: never;
    url: '/api/Client/v2/DropIn/{dropInRoomId}/tickets';
};

export type ClientDropInEnqueueErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInEnqueueError = ClientDropInEnqueueErrors[keyof ClientDropInEnqueueErrors];

export type ClientDropInEnqueueResponses = {
    /**
     * OK
     */
    200: DropInTicketApiModelDataEnvelope;
};

export type ClientDropInEnqueueResponse = ClientDropInEnqueueResponses[keyof ClientDropInEnqueueResponses];

export type ClientDropInCancelData = {
    body?: never;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/DropIn/tickets/{ticket}';
};

export type ClientDropInCancelErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInCancelError = ClientDropInCancelErrors[keyof ClientDropInCancelErrors];

export type ClientDropInCancelResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientDropInCancelResponse = ClientDropInCancelResponses[keyof ClientDropInCancelResponses];

export type ClientDropInGetTicketData = {
    body?: never;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/DropIn/tickets/{ticket}';
};

export type ClientDropInGetTicketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInGetTicketError = ClientDropInGetTicketErrors[keyof ClientDropInGetTicketErrors];

export type ClientDropInGetTicketResponses = {
    /**
     * OK
     */
    200: DropInTicketApiModelDataEnvelope;
};

export type ClientDropInGetTicketResponse = ClientDropInGetTicketResponses[keyof ClientDropInGetTicketResponses];

export type GetActiveTicketData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/DropIn/tickets/active';
};

export type GetActiveTicketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type GetActiveTicketError = GetActiveTicketErrors[keyof GetActiveTicketErrors];

export type GetActiveTicketResponses = {
    /**
     * OK
     */
    200: DropInTicketApiModelDataEnvelope;
};

export type GetActiveTicketResponse = GetActiveTicketResponses[keyof GetActiveTicketResponses];

export type GetActiveTicketForRoomData = {
    body?: never;
    path: {
        dropInRoomId: number;
    };
    query?: never;
    url: '/api/Client/v2/DropIn/{dropInRoomId}/tickets/active';
};

export type GetActiveTicketForRoomErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type GetActiveTicketForRoomError = GetActiveTicketForRoomErrors[keyof GetActiveTicketForRoomErrors];

export type GetActiveTicketForRoomResponses = {
    /**
     * OK
     */
    200: DropInTicketApiModelDataEnvelope;
};

export type GetActiveTicketForRoomResponse = GetActiveTicketForRoomResponses[keyof GetActiveTicketForRoomResponses];

export type ClientDropInUploadData = {
    body?: UserFileApiInputWritable;
    path: {
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/DropIn/tickets/{ticket}/files';
};

export type ClientDropInUploadErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInUploadError = ClientDropInUploadErrors[keyof ClientDropInUploadErrors];

export type ClientDropInUploadResponses = {
    /**
     * OK
     */
    200: FileUploadApiModelDataEnvelope;
};

export type ClientDropInUploadResponse = ClientDropInUploadResponses[keyof ClientDropInUploadResponses];

export type ClientDropInListData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/DropIn';
};

export type ClientDropInListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInListError = ClientDropInListErrors[keyof ClientDropInListErrors];

export type ClientDropInListResponses = {
    /**
     * OK
     */
    200: DropInApiModelListDataEnvelope;
};

export type ClientDropInListResponse = ClientDropInListResponses[keyof ClientDropInListResponses];

export type ClientDropInGetData = {
    body?: never;
    path: {
        unitId: number;
        dropInRoomId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/DropIn/{dropInRoomId}';
};

export type ClientDropInGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInGetError = ClientDropInGetErrors[keyof ClientDropInGetErrors];

export type ClientDropInGetResponses = {
    /**
     * OK
     */
    200: DropInApiModelDataEnvelope;
};

export type ClientDropInGetResponse = ClientDropInGetResponses[keyof ClientDropInGetResponses];

export type ClientDropInGetByUrlAliasData = {
    body?: never;
    path: {
        unitId: number;
        urlAlias: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/DropIn/url/{urlAlias}';
};

export type ClientDropInGetByUrlAliasErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientDropInGetByUrlAliasError = ClientDropInGetByUrlAliasErrors[keyof ClientDropInGetByUrlAliasErrors];

export type ClientDropInGetByUrlAliasResponses = {
    /**
     * OK
     */
    200: DropInApiModelDataEnvelope;
};

export type ClientDropInGetByUrlAliasResponse = ClientDropInGetByUrlAliasResponses[keyof ClientDropInGetByUrlAliasResponses];

export type ClientFormsListData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        opportunity?: FormOpportunity;
        conditionId?: number;
    };
    url: '/api/Client/v2/units/{unitId}/Forms';
};

export type ClientFormsListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientFormsListError = ClientFormsListErrors[keyof ClientFormsListErrors];

export type ClientFormsListResponses = {
    /**
     * OK
     */
    200: FormApiModelListDataEnvelope;
};

export type ClientFormsListResponse = ClientFormsListResponses[keyof ClientFormsListResponses];

export type ClientFormsGetFormGraphData = {
    body?: never;
    path: {
        unitId: number;
        formId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Forms/{formId}';
};

export type ClientFormsGetFormGraphErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientFormsGetFormGraphError = ClientFormsGetFormGraphErrors[keyof ClientFormsGetFormGraphErrors];

export type ClientFormsGetFormGraphResponses = {
    /**
     * OK
     */
    200: FormGraphApiModelDataEnvelope;
};

export type ClientFormsGetFormGraphResponse = ClientFormsGetFormGraphResponses[keyof ClientFormsGetFormGraphResponses];

export type ClientFormsGetRespondantData = {
    body?: never;
    path: {
        unitId: number;
        respondantId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Forms/Respondants/{respondantId}';
};

export type ClientFormsGetRespondantErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientFormsGetRespondantError = ClientFormsGetRespondantErrors[keyof ClientFormsGetRespondantErrors];

export type ClientFormsGetRespondantResponses = {
    /**
     * OK
     */
    200: RespondantApiModelDataEnvelope;
};

export type ClientFormsGetRespondantResponse = ClientFormsGetRespondantResponses[keyof ClientFormsGetRespondantResponses];

export type ClientFormsSaveAnswersData = {
    body: Array<AnswerApiModel>;
    path: {
        unitId: number;
        respondantId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Forms/Respondants/{respondantId}/Answers';
};

export type ClientFormsSaveAnswersErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientFormsSaveAnswersError = ClientFormsSaveAnswersErrors[keyof ClientFormsSaveAnswersErrors];

export type ClientFormsSaveAnswersResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientFormsSaveAnswersResponse = ClientFormsSaveAnswersResponses[keyof ClientFormsSaveAnswersResponses];

export type ClientFormsSetRespondantCompleteData = {
    body?: never;
    path: {
        unitId: number;
        respondantId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Forms/Respondants/{respondantId}/completion';
};

export type ClientFormsSetRespondantCompleteErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientFormsSetRespondantCompleteError = ClientFormsSetRespondantCompleteErrors[keyof ClientFormsSetRespondantCompleteErrors];

export type ClientFormsSetRespondantCompleteResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientFormsSetRespondantCompleteResponse = ClientFormsSetRespondantCompleteResponses[keyof ClientFormsSetRespondantCompleteResponses];

export type ClientGuiComponentsListData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/GuiComponents';
};

export type ClientGuiComponentsListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientGuiComponentsListError = ClientGuiComponentsListErrors[keyof ClientGuiComponentsListErrors];

export type ClientGuiComponentsListResponses = {
    /**
     * OK
     */
    200: GuiComponentApiModelListDataEnvelope;
};

export type ClientGuiComponentsListResponse = ClientGuiComponentsListResponses[keyof ClientGuiComponentsListResponses];

export type ClientIdentityDeleteData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity';
};

export type ClientIdentityDeleteErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityDeleteError = ClientIdentityDeleteErrors[keyof ClientIdentityDeleteErrors];

export type ClientIdentityDeleteResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientIdentityDeleteResponse = ClientIdentityDeleteResponses[keyof ClientIdentityDeleteResponses];

export type ClientIdentityGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity';
};

export type ClientIdentityGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityGetError = ClientIdentityGetErrors[keyof ClientIdentityGetErrors];

export type ClientIdentityGetResponses = {
    /**
     * OK
     */
    200: IdentityApiModelDataEnvelope;
};

export type ClientIdentityGetResponse = ClientIdentityGetResponses[keyof ClientIdentityGetResponses];

export type ClientIdentityUpdateData = {
    body?: UpdateIdentityApiInput;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity';
};

export type ClientIdentityUpdateErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityUpdateError = ClientIdentityUpdateErrors[keyof ClientIdentityUpdateErrors];

export type ClientIdentityUpdateResponses = {
    /**
     * OK
     */
    200: IdentityApiModelDataEnvelope;
};

export type ClientIdentityUpdateResponse = ClientIdentityUpdateResponses[keyof ClientIdentityUpdateResponses];

export type ClientIdentityInviteablePersonsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity/InviteablePersons';
};

export type ClientIdentityInviteablePersonsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityInviteablePersonsError = ClientIdentityInviteablePersonsErrors[keyof ClientIdentityInviteablePersonsErrors];

export type ClientIdentityInviteablePersonsResponses = {
    /**
     * OK
     */
    200: InviteablePersonApiModelListDataEnvelope;
};

export type ClientIdentityInviteablePersonsResponse = ClientIdentityInviteablePersonsResponses[keyof ClientIdentityInviteablePersonsResponses];

export type ClientIdentityCanDeleteData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity/CanDelete';
};

export type ClientIdentityCanDeleteErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityCanDeleteError = ClientIdentityCanDeleteErrors[keyof ClientIdentityCanDeleteErrors];

export type ClientIdentityCanDeleteResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientIdentityCanDeleteResponse = ClientIdentityCanDeleteResponses[keyof ClientIdentityCanDeleteResponses];

export type ClientIdentitySignOutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity/SignOut';
};

export type ClientIdentitySignOutErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentitySignOutError = ClientIdentitySignOutErrors[keyof ClientIdentitySignOutErrors];

export type ClientIdentitySignOutResponses = {
    /**
     * OK
     */
    200: SignOutApiModelDataEnvelope;
};

export type ClientIdentitySignOutResponse = ClientIdentitySignOutResponses[keyof ClientIdentitySignOutResponses];

export type ClientIdentityIsAliveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity/IsAlive';
};

export type ClientIdentityIsAliveErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityIsAliveError = ClientIdentityIsAliveErrors[keyof ClientIdentityIsAliveErrors];

export type ClientIdentityIsAliveResponses = {
    /**
     * OK
     */
    200: BooleanDataEnvelope;
};

export type ClientIdentityIsAliveResponse = ClientIdentityIsAliveResponses[keyof ClientIdentityIsAliveResponses];

export type ClientIdentityIsAliveOutsiderData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Identity/IsAliveOutsider';
};

export type ClientIdentityIsAliveOutsiderErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientIdentityIsAliveOutsiderError = ClientIdentityIsAliveOutsiderErrors[keyof ClientIdentityIsAliveOutsiderErrors];

export type ClientIdentityIsAliveOutsiderResponses = {
    /**
     * OK
     */
    200: BooleanDataEnvelope;
};

export type ClientIdentityIsAliveOutsiderResponse = ClientIdentityIsAliveOutsiderResponses[keyof ClientIdentityIsAliveOutsiderResponses];

export type ClientMessagingListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/MessagingConversations';
};

export type ClientMessagingListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientMessagingListError = ClientMessagingListErrors[keyof ClientMessagingListErrors];

export type ClientMessagingListResponses = {
    /**
     * OK
     */
    200: MessagingConversationApiModelListDataEnvelope;
};

export type ClientMessagingListResponse = ClientMessagingListResponses[keyof ClientMessagingListResponses];

export type ClientMessagingGetData = {
    body?: never;
    path: {
        caseId: number;
    };
    query?: never;
    url: '/api/Client/v2/MessagingConversations/{caseId}';
};

export type ClientMessagingGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientMessagingGetError = ClientMessagingGetErrors[keyof ClientMessagingGetErrors];

export type ClientMessagingGetResponses = {
    /**
     * OK
     */
    200: MessagingConversationApiModelDataEnvelope;
};

export type ClientMessagingGetResponse = ClientMessagingGetResponses[keyof ClientMessagingGetResponses];

export type ClientMessagingGetCaseData = {
    body?: never;
    path: {
        caseId: number;
    };
    query?: never;
    url: '/api/Client/v2/MessagingConversations/case/{caseId}';
};

export type ClientMessagingGetCaseErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientMessagingGetCaseError = ClientMessagingGetCaseErrors[keyof ClientMessagingGetCaseErrors];

export type ClientMessagingGetCaseResponses = {
    /**
     * OK
     */
    200: ClientPersonalizedCaseApiModelDataEnvelope;
};

export type ClientMessagingGetCaseResponse = ClientMessagingGetCaseResponses[keyof ClientMessagingGetCaseResponses];

export type ClientMessagingUpdateLegalGuardiansData = {
    body?: MessagingUpdateLegalGuardiansApiInput;
    path: {
        unitId: number;
        caseId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/MessagingConversations/{caseId}/LegalGuardians';
};

export type ClientMessagingUpdateLegalGuardiansErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientMessagingUpdateLegalGuardiansError = ClientMessagingUpdateLegalGuardiansErrors[keyof ClientMessagingUpdateLegalGuardiansErrors];

export type ClientMessagingUpdateLegalGuardiansResponses = {
    /**
     * OK
     */
    200: MessagingConversationApiModelDataEnvelope;
};

export type ClientMessagingUpdateLegalGuardiansResponse = ClientMessagingUpdateLegalGuardiansResponses[keyof ClientMessagingUpdateLegalGuardiansResponses];

export type ClientMessagingCompletionCompleteCaseData = {
    body?: never;
    path: {
        caseId: number;
    };
    query?: never;
    url: '/api/Client/v2/MessagingConversations/{caseId}/completed';
};

export type ClientMessagingCompletionCompleteCaseErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
};

export type ClientMessagingCompletionCompleteCaseError = ClientMessagingCompletionCompleteCaseErrors[keyof ClientMessagingCompletionCompleteCaseErrors];

export type ClientMessagingCompletionCompleteCaseResponses = {
    /**
     * No Content
     */
    204: void;
};

export type ClientMessagingCompletionCompleteCaseResponse = ClientMessagingCompletionCompleteCaseResponses[keyof ClientMessagingCompletionCompleteCaseResponses];

export type ClientNotificationTargetsDeleteStandardTargetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/NotificationTargets/standardTarget';
};

export type ClientNotificationTargetsDeleteStandardTargetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientNotificationTargetsDeleteStandardTargetError = ClientNotificationTargetsDeleteStandardTargetErrors[keyof ClientNotificationTargetsDeleteStandardTargetErrors];

export type ClientNotificationTargetsDeleteStandardTargetResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientNotificationTargetsDeleteStandardTargetResponse = ClientNotificationTargetsDeleteStandardTargetResponses[keyof ClientNotificationTargetsDeleteStandardTargetResponses];

export type ClientNotificationTargetsSetStandardTargetData = {
    body?: SetCloudMessagingTargetInput;
    path?: never;
    query?: never;
    url: '/api/Client/v2/NotificationTargets/standardTarget';
};

export type ClientNotificationTargetsSetStandardTargetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientNotificationTargetsSetStandardTargetError = ClientNotificationTargetsSetStandardTargetErrors[keyof ClientNotificationTargetsSetStandardTargetErrors];

export type ClientNotificationTargetsSetStandardTargetResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientNotificationTargetsSetStandardTargetResponse = ClientNotificationTargetsSetStandardTargetResponses[keyof ClientNotificationTargetsSetStandardTargetResponses];

export type ClientNotificationTargetsDeleteVoipTargetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/NotificationTargets/voipTarget';
};

export type ClientNotificationTargetsDeleteVoipTargetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientNotificationTargetsDeleteVoipTargetError = ClientNotificationTargetsDeleteVoipTargetErrors[keyof ClientNotificationTargetsDeleteVoipTargetErrors];

export type ClientNotificationTargetsDeleteVoipTargetResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientNotificationTargetsDeleteVoipTargetResponse = ClientNotificationTargetsDeleteVoipTargetResponses[keyof ClientNotificationTargetsDeleteVoipTargetResponses];

export type ClientNotificationTargetsSetVoipTargetData = {
    body?: SetCloudMessagingTargetInput;
    path?: never;
    query?: never;
    url: '/api/Client/v2/NotificationTargets/voipTarget';
};

export type ClientNotificationTargetsSetVoipTargetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientNotificationTargetsSetVoipTargetError = ClientNotificationTargetsSetVoipTargetErrors[keyof ClientNotificationTargetsSetVoipTargetErrors];

export type ClientNotificationTargetsSetVoipTargetResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientNotificationTargetsSetVoipTargetResponse = ClientNotificationTargetsSetVoipTargetResponses[keyof ClientNotificationTargetsSetVoipTargetResponses];

export type ClientPaymentsPaymentServicesData = {
    body?: never;
    path: {
        unitId: number;
        paymentBillId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Payments/{paymentBillId}/Services';
};

export type ClientPaymentsPaymentServicesErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientPaymentsPaymentServicesError = ClientPaymentsPaymentServicesErrors[keyof ClientPaymentsPaymentServicesErrors];

export type ClientPaymentsPaymentServicesResponses = {
    /**
     * OK
     */
    200: PaymentServiceApiModelListDataEnvelope;
};

export type ClientPaymentsPaymentServicesResponse = ClientPaymentsPaymentServicesResponses[keyof ClientPaymentsPaymentServicesResponses];

export type ClientReceptionConditionsListData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/receptions/{receptionId}/Conditions';
};

export type ClientReceptionConditionsListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientReceptionConditionsListError = ClientReceptionConditionsListErrors[keyof ClientReceptionConditionsListErrors];

export type ClientReceptionConditionsListResponses = {
    /**
     * OK
     */
    200: ClientConditionApiModelListDataEnvelope;
};

export type ClientReceptionConditionsListResponse = ClientReceptionConditionsListResponses[keyof ClientReceptionConditionsListResponses];

export type ClientRegistrationGetRegistrationData = {
    body?: never;
    path: {
        registrationTicket: string;
    };
    query?: never;
    url: '/api/Client/v2/Registration/Registration/{registrationTicket}';
};

export type ClientRegistrationGetRegistrationErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientRegistrationGetRegistrationError = ClientRegistrationGetRegistrationErrors[keyof ClientRegistrationGetRegistrationErrors];

export type ClientRegistrationGetRegistrationResponses = {
    /**
     * OK
     */
    200: GetRegistrationApiModelDataEnvelope;
};

export type ClientRegistrationGetRegistrationResponse = ClientRegistrationGetRegistrationResponses[keyof ClientRegistrationGetRegistrationResponses];

export type ClientRegistrationCompleteRegistrationData = {
    body?: UpdateIdentityApiInput;
    path: {
        registrationTicket: string;
    };
    query?: never;
    url: '/api/Client/v2/Registration/Registration/{registrationTicket}';
};

export type ClientRegistrationCompleteRegistrationErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientRegistrationCompleteRegistrationError = ClientRegistrationCompleteRegistrationErrors[keyof ClientRegistrationCompleteRegistrationErrors];

export type ClientRegistrationCompleteRegistrationResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientRegistrationCompleteRegistrationResponse = ClientRegistrationCompleteRegistrationResponses[keyof ClientRegistrationCompleteRegistrationResponses];

export type ClientSmsStartAuthData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        number?: string;
        countryCode?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/SendCode';
};

export type ClientSmsStartAuthErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSmsStartAuthError = ClientSmsStartAuthErrors[keyof ClientSmsStartAuthErrors];

export type ClientSmsStartAuthResponses = {
    /**
     * OK
     */
    200: SmsStartAuthModelDataEnvelope;
};

export type ClientSmsStartAuthResponse = ClientSmsStartAuthResponses[keyof ClientSmsStartAuthResponses];

export type ClientSmsStartAuthWithCallTicketData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        callTicket?: string;
        countryCode?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/SendCodeWithCallTicket';
};

export type ClientSmsStartAuthWithCallTicketErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSmsStartAuthWithCallTicketError = ClientSmsStartAuthWithCallTicketErrors[keyof ClientSmsStartAuthWithCallTicketErrors];

export type ClientSmsStartAuthWithCallTicketResponses = {
    /**
     * OK
     */
    200: SmsStartAuthModelDataEnvelope;
};

export type ClientSmsStartAuthWithCallTicketResponse = ClientSmsStartAuthWithCallTicketResponses[keyof ClientSmsStartAuthWithCallTicketResponses];

export type ClientSmsReSendCodeData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        attemptId?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/ReSendCode';
};

export type ClientSmsReSendCodeErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSmsReSendCodeError = ClientSmsReSendCodeErrors[keyof ClientSmsReSendCodeErrors];

export type ClientSmsReSendCodeResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientSmsReSendCodeResponse = ClientSmsReSendCodeResponses[keyof ClientSmsReSendCodeResponses];

export type ClientSmsConfirmCodeData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        attemptId?: string;
        code?: string;
        sessionLifetime?: number;
    };
    url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/ConfirmCode';
};

export type ClientSmsConfirmCodeErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSmsConfirmCodeError = ClientSmsConfirmCodeErrors[keyof ClientSmsConfirmCodeErrors];

export type ClientSmsConfirmCodeResponses = {
    /**
     * OK
     */
    200: SmsConfirmCodeApiResultDataEnvelope;
};

export type ClientSmsConfirmCodeResponse = ClientSmsConfirmCodeResponses[keyof ClientSmsConfirmCodeResponses];

export type ClientSmsPreRegisteredNumberData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        callticket?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Auth/Methods/Sms/PreRegisteredNumber';
};

export type ClientSmsPreRegisteredNumberErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSmsPreRegisteredNumberError = ClientSmsPreRegisteredNumberErrors[keyof ClientSmsPreRegisteredNumberErrors];

export type ClientSmsPreRegisteredNumberResponses = {
    /**
     * OK
     */
    200: StringDataEnvelope;
};

export type ClientSmsPreRegisteredNumberResponse = ClientSmsPreRegisteredNumberResponses[keyof ClientSmsPreRegisteredNumberResponses];

export type ClientSurveysGetSurveyData = {
    body?: never;
    path: {
        unitId: number;
        alias: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Surveys/{alias}';
};

export type ClientSurveysGetSurveyErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSurveysGetSurveyError = ClientSurveysGetSurveyErrors[keyof ClientSurveysGetSurveyErrors];

export type ClientSurveysGetSurveyResponses = {
    /**
     * OK
     */
    200: SurveyApiModelDataEnvelope;
};

export type ClientSurveysGetSurveyResponse = ClientSurveysGetSurveyResponses[keyof ClientSurveysGetSurveyResponses];

export type ClientSurveysAnswerSurveyData = {
    body?: SurveyAnswerApiModel;
    path: {
        unitId: number;
        alias: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Surveys/{alias}';
};

export type ClientSurveysAnswerSurveyErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientSurveysAnswerSurveyError = ClientSurveysAnswerSurveyErrors[keyof ClientSurveysAnswerSurveyErrors];

export type ClientSurveysAnswerSurveyResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientSurveysAnswerSurveyResponse = ClientSurveysAnswerSurveyResponses[keyof ClientSurveysAnswerSurveyResponses];

export type ClientThemeGetPublicThemeData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/Theme/Public';
};

export type ClientThemeGetPublicThemeErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientThemeGetPublicThemeError = ClientThemeGetPublicThemeErrors[keyof ClientThemeGetPublicThemeErrors];

export type ClientThemeGetPublicThemeResponses = {
    /**
     * OK
     */
    200: StringObjectDictionaryDataEnvelope;
};

export type ClientThemeGetPublicThemeResponse = ClientThemeGetPublicThemeResponses[keyof ClientThemeGetPublicThemeResponses];

export type ClientTimeslotsTimeslotsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
        fromTime?: string;
        toTime?: string;
        specialityId?: number;
        conditionId?: number;
        filterableUnitId?: number;
        resourceId?: number;
        physicalLocationId?: number;
        additionalParameters?: {
            [key: string]: string;
        };
        localityType?: LocalityType;
        searchContextId?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Timeslots';
};

export type ClientTimeslotsTimeslotsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsTimeslotsError = ClientTimeslotsTimeslotsErrors[keyof ClientTimeslotsTimeslotsErrors];

export type ClientTimeslotsTimeslotsResponses = {
    /**
     * OK
     */
    200: TimeslotApiModelListDataEnvelope;
};

export type ClientTimeslotsTimeslotsResponse = ClientTimeslotsTimeslotsResponses[keyof ClientTimeslotsTimeslotsResponses];

export type ClientTimeslotsTimeslotData = {
    body?: never;
    path: {
        unitId: number;
        id: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Timeslots/{id}';
};

export type ClientTimeslotsTimeslotErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsTimeslotError = ClientTimeslotsTimeslotErrors[keyof ClientTimeslotsTimeslotErrors];

export type ClientTimeslotsTimeslotResponses = {
    /**
     * OK
     */
    200: TimeslotApiModelDataEnvelope;
};

export type ClientTimeslotsTimeslotResponse = ClientTimeslotsTimeslotResponses[keyof ClientTimeslotsTimeslotResponses];

export type ClientTimeslotsSearchLocalityAvailabilityData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
        fromTime?: string;
        toTime?: string;
        specialityId?: string;
        conditionId?: string;
        filterableUnitId?: string;
        resourceId?: string;
        physicalLocationId?: number;
        additionalParameters?: {
            [key: string]: string;
        };
        localityType?: LocalityType;
        searchContextId?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Timeslots/Availability';
};

export type ClientTimeslotsSearchLocalityAvailabilityErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsSearchLocalityAvailabilityError = ClientTimeslotsSearchLocalityAvailabilityErrors[keyof ClientTimeslotsSearchLocalityAvailabilityErrors];

export type ClientTimeslotsSearchLocalityAvailabilityResponses = {
    /**
     * OK
     */
    200: TimeslotAvailabilityGroupingApiModelDataEnvelope;
};

export type ClientTimeslotsSearchLocalityAvailabilityResponse = ClientTimeslotsSearchLocalityAvailabilityResponses[keyof ClientTimeslotsSearchLocalityAvailabilityResponses];

export type ClientTimeslotsGetAvailabilityCountsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
        fromTime?: string;
        toTime?: string;
        specialityId?: number;
        conditionId?: number;
        filterableUnitId?: number;
        resourceId?: number;
        physicalLocationId?: number;
        additionalParameters?: {
            [key: string]: string;
        };
        localityType?: LocalityType;
        searchContextId?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Timeslots/AvailabilityCounts';
};

export type ClientTimeslotsGetAvailabilityCountsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsGetAvailabilityCountsError = ClientTimeslotsGetAvailabilityCountsErrors[keyof ClientTimeslotsGetAvailabilityCountsErrors];

export type ClientTimeslotsGetAvailabilityCountsResponses = {
    /**
     * OK
     */
    200: TimeslotAvailabilityCountsApiModelDataEnvelope;
};

export type ClientTimeslotsGetAvailabilityCountsResponse = ClientTimeslotsGetAvailabilityCountsResponses[keyof ClientTimeslotsGetAvailabilityCountsResponses];

export type ClientTimeslotsGetSearchCapabilitiesData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Timeslots/searchcapabilities';
};

export type ClientTimeslotsGetSearchCapabilitiesErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsGetSearchCapabilitiesError = ClientTimeslotsGetSearchCapabilitiesErrors[keyof ClientTimeslotsGetSearchCapabilitiesErrors];

export type ClientTimeslotsGetSearchCapabilitiesResponses = {
    /**
     * OK
     */
    200: SearchCapabilitiesApiModelDataEnvelope;
};

export type ClientTimeslotsGetSearchCapabilitiesResponse = ClientTimeslotsGetSearchCapabilitiesResponses[keyof ClientTimeslotsGetSearchCapabilitiesResponses];

export type ClientTimeslotsBookSlotData = {
    body?: BookSlotApiInput;
    path: {
        unitId: number;
        id: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Timeslots/{id}/book';
};

export type ClientTimeslotsBookSlotErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsBookSlotError = ClientTimeslotsBookSlotErrors[keyof ClientTimeslotsBookSlotErrors];

export type ClientTimeslotsBookSlotResponses = {
    /**
     * OK
     */
    200: AppointmentApiModelDataEnvelope;
};

export type ClientTimeslotsBookSlotResponse = ClientTimeslotsBookSlotResponses[keyof ClientTimeslotsBookSlotResponses];

export type ClientTimeslotsGetRescheduleTimeslotsData = {
    body?: never;
    path: {
        unitId: number;
        ticket: string;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
        fromTime?: string;
        toTime?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Timeslots/Reschedule/{ticket}';
};

export type ClientTimeslotsGetRescheduleTimeslotsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsGetRescheduleTimeslotsError = ClientTimeslotsGetRescheduleTimeslotsErrors[keyof ClientTimeslotsGetRescheduleTimeslotsErrors];

export type ClientTimeslotsGetRescheduleTimeslotsResponses = {
    /**
     * OK
     */
    200: TimeslotApiModelListDataEnvelope;
};

export type ClientTimeslotsGetRescheduleTimeslotsResponse = ClientTimeslotsGetRescheduleTimeslotsResponses[keyof ClientTimeslotsGetRescheduleTimeslotsResponses];

export type ClientTimeslotsRebookWithNewTimeslotData = {
    body?: RebookWithNewTimeslotInput;
    path: {
        unitId: number;
        ticket: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/Timeslots/Reschedule/{ticket}';
};

export type ClientTimeslotsRebookWithNewTimeslotErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsRebookWithNewTimeslotError = ClientTimeslotsRebookWithNewTimeslotErrors[keyof ClientTimeslotsRebookWithNewTimeslotErrors];

export type ClientTimeslotsRebookWithNewTimeslotResponses = {
    /**
     * OK
     */
    200: AppointmentApiModelDataEnvelope;
};

export type ClientTimeslotsRebookWithNewTimeslotResponse = ClientTimeslotsRebookWithNewTimeslotResponses[keyof ClientTimeslotsRebookWithNewTimeslotResponses];

export type ClientTimeslotsGetRescheduleAvailabilityCountsData = {
    body?: never;
    path: {
        unitId: number;
        ticket: string;
    };
    query?: {
        fromDate?: string;
        toDate?: string;
        fromTime?: string;
        toTime?: string;
    };
    url: '/api/Client/v2/units/{unitId}/Timeslots/RescheduleAvailabilityCounts/{ticket}';
};

export type ClientTimeslotsGetRescheduleAvailabilityCountsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientTimeslotsGetRescheduleAvailabilityCountsError = ClientTimeslotsGetRescheduleAvailabilityCountsErrors[keyof ClientTimeslotsGetRescheduleAvailabilityCountsErrors];

export type ClientTimeslotsGetRescheduleAvailabilityCountsResponses = {
    /**
     * OK
     */
    200: TimeslotAvailabilityCountsApiModelDataEnvelope;
};

export type ClientTimeslotsGetRescheduleAvailabilityCountsResponse = ClientTimeslotsGetRescheduleAvailabilityCountsResponses[keyof ClientTimeslotsGetRescheduleAvailabilityCountsResponses];

export type ClientUnitsListUnitsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/tree';
};

export type ClientUnitsListUnitsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUnitsListUnitsError = ClientUnitsListUnitsErrors[keyof ClientUnitsListUnitsErrors];

export type ClientUnitsListUnitsResponses = {
    /**
     * OK
     */
    200: UnitModelDataEnvelope;
};

export type ClientUnitsListUnitsResponse = ClientUnitsListUnitsResponses[keyof ClientUnitsListUnitsResponses];

export type ClientUnitsGetData = {
    body?: never;
    path: {
        unitId: number;
        platform: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/config/{platform}';
};

export type ClientUnitsGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUnitsGetError = ClientUnitsGetErrors[keyof ClientUnitsGetErrors];

export type ClientUnitsGetResponses = {
    /**
     * OK
     */
    200: UnitConfigApiModelDataEnvelope;
};

export type ClientUnitsGetResponse = ClientUnitsGetResponses[keyof ClientUnitsGetResponses];

export type ClientUnitsGetThemeData = {
    body?: never;
    path: {
        unitId: number;
        platform: string;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/theme/{platform}';
};

export type ClientUnitsGetThemeErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUnitsGetThemeError = ClientUnitsGetThemeErrors[keyof ClientUnitsGetThemeErrors];

export type ClientUnitsGetThemeResponses = {
    /**
     * OK
     */
    200: StringObjectDictionaryDataEnvelope;
};

export type ClientUnitsGetThemeResponse = ClientUnitsGetThemeResponses[keyof ClientUnitsGetThemeResponses];

export type ClientUnitsGetAboutData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/about';
};

export type ClientUnitsGetAboutErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUnitsGetAboutError = ClientUnitsGetAboutErrors[keyof ClientUnitsGetAboutErrors];

export type ClientUnitsGetAboutResponses = {
    /**
     * OK
     */
    200: UnitAboutApiModelDataEnvelope;
};

export type ClientUnitsGetAboutResponse = ClientUnitsGetAboutResponses[keyof ClientUnitsGetAboutResponses];

export type ClientUnitsGetTextsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        aliases?: string;
    };
    url: '/api/Client/v2/units/{unitId}/texts';
};

export type ClientUnitsGetTextsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUnitsGetTextsError = ClientUnitsGetTextsErrors[keyof ClientUnitsGetTextsErrors];

export type ClientUnitsGetTextsResponses = {
    /**
     * OK
     */
    200: StringStringDictionaryDataEnvelope;
};

export type ClientUnitsGetTextsResponse = ClientUnitsGetTextsResponses[keyof ClientUnitsGetTextsResponses];

export type ClientUnitsGetIdentifierConflictsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query: {
        countryCode: string;
        nationalIdentityNumber?: string;
        phoneNumber?: string;
        excludedClientId?: number;
    };
    url: '/api/Client/v2/units/{unitId}/IdentifierConflicts';
};

export type ClientUnitsGetIdentifierConflictsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUnitsGetIdentifierConflictsError = ClientUnitsGetIdentifierConflictsErrors[keyof ClientUnitsGetIdentifierConflictsErrors];

export type ClientUnitsGetIdentifierConflictsResponses = {
    /**
     * OK
     */
    200: IdentifierConflictsApiModelDataEnvelope;
};

export type ClientUnitsGetIdentifierConflictsResponse = ClientUnitsGetIdentifierConflictsResponses[keyof ClientUnitsGetIdentifierConflictsResponses];

export type ClientUsageAgreementsGetDocumentsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/UsageAgreements';
};

export type ClientUsageAgreementsGetDocumentsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUsageAgreementsGetDocumentsError = ClientUsageAgreementsGetDocumentsErrors[keyof ClientUsageAgreementsGetDocumentsErrors];

export type ClientUsageAgreementsGetDocumentsResponses = {
    /**
     * OK
     */
    200: SignaturesDataEnvelope;
};

export type ClientUsageAgreementsGetDocumentsResponse = ClientUsageAgreementsGetDocumentsResponses[keyof ClientUsageAgreementsGetDocumentsResponses];

export type ClientUsageAgreementsAgreeToDocumentData = {
    body?: SignDocumentApiModel;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/UsageAgreements';
};

export type ClientUsageAgreementsAgreeToDocumentErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ClientUsageAgreementsAgreeToDocumentError = ClientUsageAgreementsAgreeToDocumentErrors[keyof ClientUsageAgreementsAgreeToDocumentErrors];

export type ClientUsageAgreementsAgreeToDocumentResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type ClientUsageAgreementsAgreeToDocumentResponse = ClientUsageAgreementsAgreeToDocumentResponses[keyof ClientUsageAgreementsAgreeToDocumentResponses];

export type CurrencyGetData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/Currency';
};

export type CurrencyGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type CurrencyGetError = CurrencyGetErrors[keyof CurrencyGetErrors];

export type CurrencyGetResponses = {
    /**
     * OK
     */
    200: CurrencyCodeApiModelDataEnvelope;
};

export type CurrencyGetResponse = CurrencyGetResponses[keyof CurrencyGetResponses];

export type DemandManagementIsMessagingOpenData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/receptions/{receptionId}/demand-management/messaging';
};

export type DemandManagementIsMessagingOpenResponses = {
    /**
     * OK
     */
    200: DemandManagementStatus;
};

export type DemandManagementIsMessagingOpenResponse = DemandManagementIsMessagingOpenResponses[keyof DemandManagementIsMessagingOpenResponses];

export type DemandManagementIsTriageOpenData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/receptions/{receptionId}/demand-management/triage-entry';
};

export type DemandManagementIsTriageOpenResponses = {
    /**
     * OK
     */
    200: DemandManagementStatus;
};

export type DemandManagementIsTriageOpenResponse = DemandManagementIsTriageOpenResponses[keyof DemandManagementIsTriageOpenResponses];

export type DemandManagementGetRuleSetData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: {
        ruleSetType?: RuleSetType;
    };
    url: '/api/Client/v2/receptions/{receptionId}/demand-management/rule-set';
};

export type DemandManagementGetRuleSetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type DemandManagementGetRuleSetError = DemandManagementGetRuleSetErrors[keyof DemandManagementGetRuleSetErrors];

export type DemandManagementGetRuleSetResponses = {
    /**
     * OK
     */
    200: RuleSetHoursDataEnvelope;
};

export type DemandManagementGetRuleSetResponse = DemandManagementGetRuleSetResponses[keyof DemandManagementGetRuleSetResponses];

export type ExternalDataUploadExternalDataData = {
    body?: ExternalDataModel;
    path?: never;
    query?: never;
    url: '/api/Client/v2/ExternalData';
};

export type ExternalDataUploadExternalDataErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ExternalDataUploadExternalDataError = ExternalDataUploadExternalDataErrors[keyof ExternalDataUploadExternalDataErrors];

export type ExternalDataUploadExternalDataResponses = {
    /**
     * OK
     */
    200: GuidDataEnvelope;
};

export type ExternalDataUploadExternalDataResponse = ExternalDataUploadExternalDataResponses[keyof ExternalDataUploadExternalDataResponses];

export type HomeGuiComponentsListDeprecatedData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/HomeGuiComponents';
};

export type HomeGuiComponentsListDeprecatedErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type HomeGuiComponentsListDeprecatedError = HomeGuiComponentsListDeprecatedErrors[keyof HomeGuiComponentsListDeprecatedErrors];

export type HomeGuiComponentsListDeprecatedResponses = {
    /**
     * OK
     */
    200: HomeGuiComponentsApiModelDataEnvelope;
};

export type HomeGuiComponentsListDeprecatedResponse = HomeGuiComponentsListDeprecatedResponses[keyof HomeGuiComponentsListDeprecatedResponses];

export type HomeGuiComponentsListData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/HomeGuiComponents/v2';
};

export type HomeGuiComponentsListErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type HomeGuiComponentsListError = HomeGuiComponentsListErrors[keyof HomeGuiComponentsListErrors];

export type HomeGuiComponentsListResponses = {
    /**
     * OK
     */
    200: HomeGuiComponentsApiModelDataEnvelope;
};

export type HomeGuiComponentsListResponse = HomeGuiComponentsListResponses[keyof HomeGuiComponentsListResponses];

export type IdentityIdpSignOutIdpData = {
    body?: never;
    path?: never;
    query?: {
        returnUrl?: string;
    };
    url: '/api/Client/v2/Identity/SignOutIdp';
};

export type IdentityIdpSignOutIdpResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type IdentityIdpSignOutIdp2Data = {
    body?: never;
    path?: never;
    query?: {
        returnUrl?: string;
    };
    url: '/api/Client/v2/Identity/SignOutIdp';
};

export type IdentityIdpSignOutIdp2Responses = {
    /**
     * OK
     */
    200: unknown;
};

export type IdpAuthMethodsGetAuthMethodsData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: {
        languageCode?: string;
    };
    url: '/api/client/auth/idp/{licenceHolderId}/methods';
};

export type IdpAuthMethodsGetAuthMethodsErrors = {
    /**
     * The idp was not active on this instance or the holder did not exist.
     */
    404: unknown;
};

export type IdpAuthMethodsGetAuthMethodsResponses = {
    /**
     * The result contains the methods available.
     */
    200: Array<IdpListMethod>;
};

export type IdpAuthMethodsGetAuthMethodsResponse = IdpAuthMethodsGetAuthMethodsResponses[keyof IdpAuthMethodsGetAuthMethodsResponses];

export type InformationGatheringGetEligibilityData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/InformationGathering/Eligibility';
};

export type InformationGatheringGetEligibilityErrors = {
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type InformationGatheringGetEligibilityError = InformationGatheringGetEligibilityErrors[keyof InformationGatheringGetEligibilityErrors];

export type InformationGatheringGetEligibilityResponses = {
    /**
     * OK
     */
    200: InformationGatheringEligibilityApiModel;
};

export type InformationGatheringGetEligibilityResponse = InformationGatheringGetEligibilityResponses[keyof InformationGatheringGetEligibilityResponses];

export type InformationGatheringStoreSubmissionData = {
    /**
     * Completed patient and representative information gathered during the NHS App pilot journey.
     */
    body?: InformationGatheringSubmissionInput;
    path?: never;
    query?: never;
    url: '/api/Client/v2/InformationGathering/Submissions';
};

export type InformationGatheringStoreSubmissionErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type InformationGatheringStoreSubmissionError = InformationGatheringStoreSubmissionErrors[keyof InformationGatheringStoreSubmissionErrors];

export type InformationGatheringStoreSubmissionResponses = {
    /**
     * OK
     */
    200: InformationGatheringSubmissionApiModel;
};

export type InformationGatheringStoreSubmissionResponse = InformationGatheringStoreSubmissionResponses[keyof InformationGatheringStoreSubmissionResponses];

export type LocaleGetData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/Locale';
};

export type LocaleGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type LocaleGetError = LocaleGetErrors[keyof LocaleGetErrors];

export type LocaleGetResponses = {
    /**
     * OK
     */
    200: LocaleDataEnvelope;
};

export type LocaleGetResponse = LocaleGetResponses[keyof LocaleGetResponses];

export type NavigationStartData = {
    body?: StartNavigateRequest;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/receptions/{receptionId}/navigation/start';
};

export type NavigationStartErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Gone
     */
    410: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type NavigationStartError = NavigationStartErrors[keyof NavigationStartErrors];

export type NavigationStartResponses = {
    /**
     * OK
     */
    200: NavigationActionResult;
};

export type NavigationStartResponse = NavigationStartResponses[keyof NavigationStartResponses];

export type NotificationSettingsGetComplianceSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/NotificationSettings/Compliance';
};

export type NotificationSettingsGetComplianceSettingsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type NotificationSettingsGetComplianceSettingsError = NotificationSettingsGetComplianceSettingsErrors[keyof NotificationSettingsGetComplianceSettingsErrors];

export type NotificationSettingsGetComplianceSettingsResponses = {
    /**
     * OK
     */
    200: NotificationComplianceSettingsApiModelDataEnvelope;
};

export type NotificationSettingsGetComplianceSettingsResponse = NotificationSettingsGetComplianceSettingsResponses[keyof NotificationSettingsGetComplianceSettingsResponses];

export type NotificationSettingsUpdateComplianceSettingsData = {
    body?: UpdateNotificationComplianceSettingsApiModel;
    path?: never;
    query?: never;
    url: '/api/Client/v2/NotificationSettings/Compliance';
};

export type NotificationSettingsUpdateComplianceSettingsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type NotificationSettingsUpdateComplianceSettingsError = NotificationSettingsUpdateComplianceSettingsErrors[keyof NotificationSettingsUpdateComplianceSettingsErrors];

export type NotificationSettingsUpdateComplianceSettingsResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type NotificationSettingsUpdateComplianceSettingsResponse = NotificationSettingsUpdateComplianceSettingsResponses[keyof NotificationSettingsUpdateComplianceSettingsResponses];

export type PaymentsGetBillData = {
    body?: never;
    path: {
        paymentBillId: number;
    };
    query?: never;
    url: '/api/Client/v2/Payments/{paymentBillId}';
};

export type PaymentsGetBillErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type PaymentsGetBillError = PaymentsGetBillErrors[keyof PaymentsGetBillErrors];

export type PaymentsGetBillResponses = {
    /**
     * OK
     */
    200: PaymentApiModelDataEnvelope;
};

export type PaymentsGetBillResponse = PaymentsGetBillResponses[keyof PaymentsGetBillResponses];

export type PhysicalLocationsGetPhysicalLocationData = {
    body?: never;
    path: {
        receptionId: number;
        physicalLocationId: number;
    };
    query?: {
        languageCode?: string;
    };
    url: '/api/Client/v2/receptions/{receptionId}/PhysicalLocations/{physicalLocationId}';
};

export type PhysicalLocationsGetPhysicalLocationErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type PhysicalLocationsGetPhysicalLocationError = PhysicalLocationsGetPhysicalLocationErrors[keyof PhysicalLocationsGetPhysicalLocationErrors];

export type PhysicalLocationsGetPhysicalLocationResponses = {
    /**
     * OK
     */
    200: PhysicalLocationApiModelDataEnvelope;
};

export type PhysicalLocationsGetPhysicalLocationResponse = PhysicalLocationsGetPhysicalLocationResponses[keyof PhysicalLocationsGetPhysicalLocationResponses];

export type PhysicalLocationsGetPhysicalLocationsData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: {
        languageCode?: string;
    };
    url: '/api/Client/v2/receptions/{receptionId}/PhysicalLocations';
};

export type PhysicalLocationsGetPhysicalLocationsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type PhysicalLocationsGetPhysicalLocationsError = PhysicalLocationsGetPhysicalLocationsErrors[keyof PhysicalLocationsGetPhysicalLocationsErrors];

export type PhysicalLocationsGetPhysicalLocationsResponses = {
    /**
     * OK
     */
    200: PhysicalLocationApiModelListDataEnvelope;
};

export type PhysicalLocationsGetPhysicalLocationsResponse = PhysicalLocationsGetPhysicalLocationsResponses[keyof PhysicalLocationsGetPhysicalLocationsResponses];

export type RateGetMessagingPriceData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/Rate/{receptionId}/GetMessagingConversationPrice';
};

export type RateGetMessagingPriceErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type RateGetMessagingPriceError = RateGetMessagingPriceErrors[keyof RateGetMessagingPriceErrors];

export type RateGetMessagingPriceResponses = {
    /**
     * OK
     */
    200: RateApiModelDataEnvelope;
};

export type RateGetMessagingPriceResponse = RateGetMessagingPriceResponses[keyof RateGetMessagingPriceResponses];

export type RecentReceptionsListRecentlyVisitedData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The number of receptions to include in the response.
         */
        count?: number;
    };
    url: '/api/Client/v2/Receptions/RecentlyVisited';
};

export type RecentReceptionsListRecentlyVisitedErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type RecentReceptionsListRecentlyVisitedError = RecentReceptionsListRecentlyVisitedErrors[keyof RecentReceptionsListRecentlyVisitedErrors];

export type RecentReceptionsListRecentlyVisitedResponses = {
    /**
     * OK
     */
    200: RecentlyVisitedReceptionIEnumerableDataEnvelope;
};

export type RecentReceptionsListRecentlyVisitedResponse = RecentReceptionsListRecentlyVisitedResponses[keyof RecentReceptionsListRecentlyVisitedResponses];

export type RecentReceptionsRegisterVisitData = {
    body?: ReceptionVisitInput;
    path?: never;
    query?: never;
    url: '/api/Client/v2/Receptions/RecentlyVisited';
};

export type RecentReceptionsRegisterVisitErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type RecentReceptionsRegisterVisitError = RecentReceptionsRegisterVisitErrors[keyof RecentReceptionsRegisterVisitErrors];

export type RecentReceptionsRegisterVisitResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type RecentReceptionsRegisterVisitResponse = RecentReceptionsRegisterVisitResponses[keyof RecentReceptionsRegisterVisitResponses];

export type RecentReceptionsDeleteVisitData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/Receptions/RecentlyVisited/{receptionId}';
};

export type RecentReceptionsDeleteVisitErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type RecentReceptionsDeleteVisitError = RecentReceptionsDeleteVisitErrors[keyof RecentReceptionsDeleteVisitErrors];

export type RecentReceptionsDeleteVisitResponses = {
    /**
     * OK
     */
    200: Envelope;
};

export type RecentReceptionsDeleteVisitResponse = RecentReceptionsDeleteVisitResponses[keyof RecentReceptionsDeleteVisitResponses];

export type ReceptionListFromUnitIdData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query?: {
        unitIdAsRoot?: number;
    };
    url: '/api/Client/v2/{licenceHolderId}/Receptions';
};

export type ReceptionListFromUnitIdErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ReceptionListFromUnitIdError = ReceptionListFromUnitIdErrors[keyof ReceptionListFromUnitIdErrors];

export type ReceptionListFromUnitIdResponses = {
    /**
     * OK
     */
    200: ReceptionPathEntityListDataEnvelope;
};

export type ReceptionListFromUnitIdResponse = ReceptionListFromUnitIdResponses[keyof ReceptionListFromUnitIdResponses];

export type ReceptionSearchData = {
    body?: never;
    path: {
        licenceHolderId: number;
    };
    query: {
        query: string;
        count?: number;
    };
    url: '/api/Client/v2/{licenceHolderId}/Receptions/Search';
};

export type ReceptionSearchErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type ReceptionSearchError = ReceptionSearchErrors[keyof ReceptionSearchErrors];

export type ReceptionSearchResponses = {
    /**
     * OK
     */
    200: ReceptionSearchApiModelIListDataEnvelope;
};

export type ReceptionSearchResponse = ReceptionSearchResponses[keyof ReceptionSearchResponses];

export type RedRobinStartSessionData = {
    body?: StartSessionInput;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/RedRobin/StartSession';
};

export type RedRobinStartSessionErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Gone
     */
    410: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type RedRobinStartSessionError = RedRobinStartSessionErrors[keyof RedRobinStartSessionErrors];

export type RedRobinStartSessionResponses = {
    /**
     * OK
     */
    200: string;
};

export type RedRobinStartSessionResponse = RedRobinStartSessionResponses[keyof RedRobinStartSessionResponses];

export type RedRobinStartSessionV2Data = {
    /**
     * Starts a Red Robin session for either the subject in the authenticated identity or an explicitly supplied unverified subject.
     */
    body: StartSessionV2Input;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/RedRobin/StartSessionV2';
};

export type RedRobinStartSessionV2Errors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Gone
     */
    410: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type RedRobinStartSessionV2Error = RedRobinStartSessionV2Errors[keyof RedRobinStartSessionV2Errors];

export type RedRobinStartSessionV2Responses = {
    /**
     * OK
     */
    200: StartSessionV2Response;
};

export type RedRobinStartSessionV2Response = RedRobinStartSessionV2Responses[keyof RedRobinStartSessionV2Responses];

export type RedRobinGetPatientEntryUrlData = {
    body?: never;
    path: {
        sessionId: string;
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/RedRobin/session/{sessionId}/entryUrl';
};

export type RedRobinGetPatientEntryUrlErrors = {
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
};

export type RedRobinGetPatientEntryUrlError = RedRobinGetPatientEntryUrlErrors[keyof RedRobinGetPatientEntryUrlErrors];

export type RedRobinGetPatientEntryUrlResponses = {
    /**
     * OK
     */
    200: string;
};

export type RedRobinGetPatientEntryUrlResponse = RedRobinGetPatientEntryUrlResponses[keyof RedRobinGetPatientEntryUrlResponses];

export type RedRobinGetAccessInfoData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: never;
    url: '/api/Client/v2/units/{unitId}/RedRobin/accessInfo';
};

export type RedRobinGetAccessInfoErrors = {
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
};

export type RedRobinGetAccessInfoError = RedRobinGetAccessInfoErrors[keyof RedRobinGetAccessInfoErrors];

export type RedRobinGetAccessInfoResponses = {
    /**
     * OK
     */
    200: AccessInfo;
};

export type RedRobinGetAccessInfoResponse = RedRobinGetAccessInfoResponses[keyof RedRobinGetAccessInfoResponses];

export type SearchLimitationDeleteContextData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: {
        limitationId?: string;
    };
    url: '/api/Client/v2/receptions/{receptionId}/SearchLimitation';
};

export type SearchLimitationDeleteContextErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
};

export type SearchLimitationDeleteContextError = SearchLimitationDeleteContextErrors[keyof SearchLimitationDeleteContextErrors];

export type SearchLimitationDeleteContextResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type SearchLimitationGetSearchLimitationData = {
    body?: never;
    path: {
        receptionId: number;
    };
    query?: {
        limitationId?: string;
    };
    url: '/api/Client/v2/receptions/{receptionId}/SearchLimitation';
};

export type SearchLimitationGetSearchLimitationErrors = {
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
};

export type SearchLimitationGetSearchLimitationError = SearchLimitationGetSearchLimitationErrors[keyof SearchLimitationGetSearchLimitationErrors];

export type SearchLimitationGetSearchLimitationResponses = {
    /**
     * OK
     */
    200: SearchLimitationResult;
};

export type SearchLimitationGetSearchLimitationResponse = SearchLimitationGetSearchLimitationResponses[keyof SearchLimitationGetSearchLimitationResponses];

export type SearchLimitationCreateSearchLimitationData = {
    body?: CreateSearchLimitationArg;
    path: {
        receptionId: number;
    };
    query?: never;
    url: '/api/Client/v2/receptions/{receptionId}/SearchLimitation';
};

export type SearchLimitationCreateSearchLimitationResponses = {
    /**
     * OK
     */
    200: string;
};

export type SearchLimitationCreateSearchLimitationResponse = SearchLimitationCreateSearchLimitationResponses[keyof SearchLimitationCreateSearchLimitationResponses];

export type SessionInformationGetClientSessionInformationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/session/client';
};

export type SessionInformationGetClientSessionInformationErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type SessionInformationGetClientSessionInformationError = SessionInformationGetClientSessionInformationErrors[keyof SessionInformationGetClientSessionInformationErrors];

export type SessionInformationGetClientSessionInformationResponses = {
    /**
     * OK
     */
    200: SessionExpirationInformationApiModelDataEnvelope;
};

export type SessionInformationGetClientSessionInformationResponse = SessionInformationGetClientSessionInformationResponses[keyof SessionInformationGetClientSessionInformationResponses];

export type SessionInformationGetGuestSessionInformationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Client/v2/session/guest';
};

export type SessionInformationGetGuestSessionInformationErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
};

export type SessionInformationGetGuestSessionInformationResponses = {
    /**
     * OK
     */
    200: SessionExpirationInformationApiModel;
};

export type SessionInformationGetGuestSessionInformationResponse = SessionInformationGetGuestSessionInformationResponses[keyof SessionInformationGetGuestSessionInformationResponses];

export type TranslationSetsGetData = {
    body?: never;
    path: {
        licenceHolderId: number;
        translationSet: string;
        languageCode: string;
    };
    query?: never;
    url: '/api/Client/v2/{licenceHolderId}/TranslationSets/{translationSet}/{languageCode}';
};

export type TranslationSetsGetErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type TranslationSetsGetError = TranslationSetsGetErrors[keyof TranslationSetsGetErrors];

export type TranslationSetsGetResponses = {
    /**
     * OK
     */
    200: StringStringIReadOnlyDictionaryDataEnvelope;
};

export type TranslationSetsGetResponse = TranslationSetsGetResponses[keyof TranslationSetsGetResponses];

export type UnitsPhysicalLocationsGetPhysicalLocationsData = {
    body?: never;
    path: {
        unitId: number;
    };
    query?: {
        languageCode?: string;
    };
    url: '/api/Client/v2/units/{unitId}/PhysicalLocations';
};

export type UnitsPhysicalLocationsGetPhysicalLocationsErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type UnitsPhysicalLocationsGetPhysicalLocationsError = UnitsPhysicalLocationsGetPhysicalLocationsErrors[keyof UnitsPhysicalLocationsGetPhysicalLocationsErrors];

export type UnitsPhysicalLocationsGetPhysicalLocationsResponses = {
    /**
     * OK
     */
    200: PhysicalLocationApiModelListDataEnvelope;
};

export type UnitsPhysicalLocationsGetPhysicalLocationsResponse = UnitsPhysicalLocationsGetPhysicalLocationsResponses[keyof UnitsPhysicalLocationsGetPhysicalLocationsResponses];

export type UserFilesGetFileIdentifierData = {
    body?: UserFileApiInputWritable;
    path?: never;
    query?: never;
    url: '/api/Client/v2/UserFiles';
};

export type UserFilesGetFileIdentifierErrors = {
    /**
     * Bad request
     */
    400: Envelope;
    /**
     * Unauthorized
     */
    401: Envelope;
    /**
     * Forbidden
     */
    403: Envelope;
    /**
     * Not Found
     */
    404: Envelope;
    /**
     * Internal Server Error
     */
    500: Envelope;
};

export type UserFilesGetFileIdentifierError = UserFilesGetFileIdentifierErrors[keyof UserFilesGetFileIdentifierErrors];

export type UserFilesGetFileIdentifierResponses = {
    /**
     * OK
     */
    200: UserFileApiModelDataEnvelope;
};

export type UserFilesGetFileIdentifierResponse = UserFilesGetFileIdentifierResponses[keyof UserFilesGetFileIdentifierResponses];

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};